<template>
  <div class="RightData">
    <div ref="tripInfoPanel" class="trip-info"
      :style="{ 'display': ((captureActive || isExpandedNum != 2) && processedTrackData.length > 0 && showTripInfo) ? 'block' : 'none', 'left': isCollapsed ? '0' : '23rem',bottom: isExpandedNum == 3 ? '107px' : '367px' }">
      <header class="trip-info__header">
        <span class="trip-info__plate">{{ tripInfoHeaderDisplay }}</span>
        <div class="trip-info__actions">
          <el-button type="text" size="mini" class="trip-info__icon-btn" v-if="!qualityMode" @click="openTripEditDialog">
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button type="text" size="mini" class="trip-info__icon-btn" v-if="!qualityMode" v-permission="'waybill:export'" @click="downloadTripViewportScreenshot">
            <i class="el-icon-picture"></i>
          </el-button>
          <el-button type="text" size="mini" class="trip-info__icon-btn" @click="copyTripInfo">
            <i class="el-icon-document-copy"></i>
          </el-button>
          <el-button type="text" size="mini" class="trip-info__icon-btn trip-info__icon-btn--close" @click="closeTripInfo">
            <i class="el-icon-close"></i>
          </el-button>
        </div>
      </header>
      <div class="trip-info__summary">
        <span class="trip-info__summary-item">车机总里程：<em>{{ displayTripSummary.distance }}</em></span>
        <span class="trip-info__summary-item">总耗时：<em>{{ displayTripSummary.duration }}</em></span>
        <!-- <span class="trip-info__summary-item">已行驶：<em>{{ playedDistanceStr }}</em></span> -->
      </div>
      <div class="trip-info__body">
        <div class="trip-section">
          <h4 class="trip-section__title">开始：{{ tripStartInfo ? tripStartInfo.time : '暂无数据' }}</h4>
          <div class="trip-section__coords">
            <span>经度：{{ tripStartInfo ? Number(qualityMode ? tripStartInfo.wgsLongitude : tripStartInfo.lon).toFixed(6) : '0' }}</span>
            <span>纬度：{{ tripStartInfo ? Number(qualityMode ? tripStartInfo.wgsLatitude : tripStartInfo.lat).toFixed(6) : '0' }}</span>
          </div>
          <p class="trip-section__addr">{{ tripStartLocationDisplay }}</p>
        </div>
        <div class="trip-section">
          <h4 class="trip-section__title">结束：{{ tripEndInfo ? tripEndInfo.time : '暂无数据' }}</h4>
          <div class="trip-section__coords">
            <span>经度：{{ tripEndInfo ? Number(qualityMode ? tripEndInfo.wgsLongitude : tripEndInfo.lon).toFixed(6) : '0' }}</span>
            <span>纬度：{{ tripEndInfo ? Number(qualityMode ? tripEndInfo.wgsLatitude : tripEndInfo.lat).toFixed(6) : '0' }}</span>
          </div>
          <p class="trip-section__addr">{{ tripEndLocationDisplay }}</p>
        </div>
      </div>
    </div>
    <!-- 行程信息弹窗 -->
    <div class="trip-info-popup"
      :style="{ 'width': isCollapsed ? '100%' : 'calc(100% - 23rem)', 'height': isExpandedNum == 2 ? '100%' : 'auto', 'left': isCollapsed ? '0' : '23rem' }">
      <!-- 外层通栏右对齐；内层条宽度随按钮（非 100%） -->
      <div class="function-buttons-row" :style="{ 'display': isExpandedNum != 2 ? 'block' : 'none', 'bottom': isExpandedNum ==3 ? '107px' : '367px' }">
        <div class="function-buttons">
<!--          <el-button type="primary" plain>AI分析里程</el-button>-->
<!--          <el-button type="primary" plain>AI轨迹报告</el-button>-->
          <el-button
            v-if="trajectoryShareEnabled"
            type="primary"
            plain
            :loading="trajectoryShareSubmitting"
            v-permission="'waybill:share'" @click="onTrajectoryShareClick"
          >分享</el-button>
          <el-button type="primary" plain class="function-buttons__export" :loading="exporting" v-permission="qualityMode ? 'truck:export' : 'waybill:export'" @click="openExportDialog">数据导出</el-button>
        </div>
      </div>
      <!-- 视频播放器 -->
      <div class="video-player" :style="{ 'display': isExpandedNum != 2 ? 'block' : 'none' }">
        <div class="player-controls">
          <div class="player-controls__left">
            <template v-if="!isPlaying">
              <i style="font-size: 2rem; cursor: pointer;" class="el-icon-video-play" @click="playTrack"></i>
              <img src="@/assets/close.png" alt="" class="el-icon-video-pause" />
            </template>
            <template v-else>
              <i style="font-size: 2rem; cursor: pointer;" class="el-icon-video-pause layout-theme-text"
                @click="pauseTrack"></i>
              <img src="@/assets/closeBlack.png" alt="" @click="pauseTrack" class="el-icon-video-pause" />
            </template>
            <span class="time-display">{{ currentTime }}</span>
          </div>
          <div class="player-controls__track">
            <el-slider v-model="videoProgress" :max="100" size="small" class="progress-slider"
              tooltip-class="trip-player-slider-tooltip"
              :format-tooltip="formatSliderTooltip" @input="onProgressInput"
              @change="onProgressChange"></el-slider>
            <div v-if="qualityMode" class="quality-time-gaps" aria-label="缺报空档">
              <span v-for="gap in qualityTimeGaps" :key="gap.key" :style="{ left: gap.left + '%', width: gap.width + '%' }" :title="'缺报 ' + gap.seconds + ' 秒'" />
            </div>
            <PlaybackRangeBar v-if="!qualityMode"
              :points="fullSpeedChartPoints"
              :range-start="playbackRangeBarStart"
              :range-end="playbackRangeBarEnd"
              :progress-ratio="playbackProgressRatioFull"
              :loading="playbackRangeDragging"
              @range-change="onPlaybackRangeChange"
            />
          </div>
          <div class="player-controls__right">
            <span class="time-display">{{ totalTime }}</span>
            <div
              ref="speedPicker"
              class="speed-picker"
              @click.stop
            >
              <button
                type="button"
                class="speed-picker__trigger"
                :class="{ 'is-open': speedMenuOpen }"
                @click="toggleSpeedMenu"
              >
                <span>x{{ playbackSpeed }}</span>
                <i class="el-icon-arrow-down speed-picker__caret"></i>
              </button>
              <transition name="speed-picker-fade">
                <div
                  v-show="speedMenuOpen"
                  class="speed-picker__dropdown"
                  role="listbox"
                >
                  <ul class="speed-picker__list">
                    <li
                      v-for="opt in speedOptions"
                      :key="opt.value"
                      class="speed-picker__item"
                      :class="{ 'is-active': playbackSpeed === opt.value }"
                      role="option"
                      @click="selectPlaybackSpeed(opt.value)"
                    >
                      {{ opt.label }}
                    </li>
                  </ul>
                  <div class="speed-picker__arrow" aria-hidden="true"></div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <!-- 标签页 -->
      <div style="position: relative;z-index: 999;"
        :style="{ 'height': isExpandedNum == 1 ? '35%' : '100%', 'display': isExpandedNum == 3 ? 'none' : 'block' }">
        <div class="expand-controls">
          <div
          v-if="isExpandedNum == 1"
      class="expand-btn"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(2)"
    >
      <i style="color: #fff;" class="el-icon-caret-top"></i>
    </div>
    <div
          v-if="isExpandedNum == 1"
      class="expand-btn"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(3)"
    >
      <i style="color: #fff;" class="el-icon-caret-bottom"></i>
    </div>
          <!-- <el-button v-if="isExpandedNum == 1" type="text" @click="collapsePanel(2)" class="expand-btn">
            <i class="el-icon-caret-top"></i>
          </el-button>
          <el-button v-if="isExpandedNum == 1" type="text"  class="expand-btn">
            <i class="el-icon-caret-bottom"></i>
          </el-button> -->
        </div>
        <el-tabs v-model="activeTab" :style="{ 'height': isExpandedNum == 1 ? '256px' : '100%' }">
          <el-tab-pane label="停靠点明细" name="first">
            <el-table border stripe class="right-data-el-table" style="margin-bottom: 0.625rem;"
              :data="currentParkingData"
              :style="{ 'height': isExpandedNum == 1 ? '9rem' : '33rem' }"
              @row-click="goToMapParking"
              @cell-mouse-enter="onParkingTableCellEnter">
              <el-table-column type="index" label="序号" width="80"></el-table-column>
              <el-table-column v-if="runRoute.some(item => item.waybillNo)" prop="waybillNo" label="运单号" min-width="160"></el-table-column>
              <el-table-column prop="duration" label="停车时长"></el-table-column>
              <el-table-column prop="startTime" label="停车开始时间"></el-table-column>
              <el-table-column prop="endTime" label="停车结束时间"></el-table-column>
              <el-table-column label="停车位置">
                <template slot-scope="scope">
                  <span @click="goToMapParking(scope.row)" class="layout-theme-text" style="cursor: pointer;">
                    {{ scope.row.location || '鼠标移上获取位置...' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleParkingSizeChange" @current-change="handleParkingCurrentChange"
              :current-page="parkingPageNum" :page-sizes="[10, 20, 50, 100]" :page-size="parkingPageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="rangeFilteredParkingData.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="轨迹明细" name="second">
            <el-table border stripe class="right-data-el-table" style="margin-bottom: 0.625rem;"
              :class="{ 'right-data-el-table--quality': qualityMode }"
              :data="currentTrackData"
              :style="{ 'height': isExpandedNum == 1 ? '9rem' : '33rem' }"
              @row-click="goToMap"
              @cell-mouse-enter="onTrackTableCellEnter">
              <el-table-column v-if="runRoute.some(item => item.waybillNo)" prop="waybillNo" label="运单号" min-width="160"></el-table-column>
              <el-table-column prop="time" label="时间" :min-width="qualityMode ? 190 : undefined"></el-table-column>
              <el-table-column prop="speed" label="速度" :min-width="qualityMode ? 110 : undefined"></el-table-column>
              <el-table-column v-if="qualityMode" prop="wgsLongitude" label="原始经度" min-width="120" />
              <el-table-column v-if="qualityMode" prop="wgsLatitude" label="原始纬度" min-width="120" />
              <el-table-column v-if="qualityMode" prop="qualityText" label="质量" min-width="140" show-overflow-tooltip />
              <el-table-column prop="mil" label="上报里程(km)" :min-width="qualityMode ? 130 : undefined"></el-table-column>
              <el-table-column prop="agl" label="方向" :min-width="qualityMode ? 80 : undefined" :formatter="formatTrackDirectionCell"></el-table-column>
              <el-table-column prop="hgt" label="海拔" :min-width="qualityMode ? 80 : undefined"></el-table-column>
              <el-table-column label="位置" :min-width="qualityMode ? 260 : undefined" :show-overflow-tooltip="qualityMode">
                <template slot-scope="scope">
                  <span @click="goToMap(scope.row)" class="layout-theme-text" style="cursor: pointer;">
                    {{ scope.row.location || '鼠标移上获取位置...' }}
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="coordinate" label="坐标"></el-table-column> -->
            </el-table>
            <el-pagination @size-change="handleTrackSizeChange" @current-change="handleTrackCurrentChange"
              :current-page="trackPageNum" :page-sizes="[10, 20, 50, 100]" :page-size="trackPageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="rangeFilteredTrackData.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="速度曲线" name="third">
            <SpeedCurvePanel
              :points="speedChartPoints"
              :quality-mode="qualityMode"
              @settings-saved="$emit('quality-settings-saved', $event)"
              :active="activeTab === 'third'"
              :height="isExpandedNum == 1 ? '9rem' : '33rem'"
              @point-click="onSpeedCurvePointClick"
            />
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
    <div class="expand-controls-fiex">
       <div
          v-if="isExpandedNum == 2"
      class="expand-btn expand-controls-top"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(1)"
      :style="{ 'left':!isCollapsed? 'calc(50% + 9.5rem)':'calc(50% - 1rem)'}"
    >
      <i style="color: #fff;" class="el-icon-caret-bottom"></i>
    </div>
     <div
          v-if="isExpandedNum == 3"
      class="expand-btn expand-controls-bottom"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(1)"
      :style="{ 'left':!isCollapsed? 'calc(50% + 9.5rem)':'calc(50% - 1rem)'}"
    >
      <i style="color: #fff;" class="el-icon-caret-top"></i>
    </div>
      <!-- <el-button v-if="isExpandedNum == 2" type="text" @click="collapsePanel(1)" class="expand-btn expand-controls-top" :style="{ 'left':!isCollapsed? 'calc(50% + 10.5rem)':'calc(50% - 1rem)'}">
        <i class="el-icon-caret-bottom"></i>
      </el-button>
      <el-button v-if="isExpandedNum == 3" type="text" @click="collapsePanel(1)"
        class="expand-btn expand-controls-bottom" :style="{ 'left':!isCollapsed? 'calc(50% + 10.5rem)':'calc(50% - 1rem)'}">
        <i class="el-icon-caret-top"></i>
      </el-button> -->
    </div>
    <el-dialog
      title="数据导出"
      :visible.sync="exportDialogVisible"
      width="420px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="export-dialog-body">
        <el-checkbox
          v-model="exportOptionParkingOnly"
          @change="onExportOptionParkingOnlyChange"
        >只解析停靠点地址</el-checkbox>
        <el-checkbox
          v-model="exportOptionFull"
          @change="onExportOptionFullChange"
        >全部解析</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="exporting" v-permission="'waybill:export'" @click="confirmExportFromDialog">导出</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修正地址文案"
      :visible.sync="tripEditDialogVisible"
      width="780px"
      append-to-body
      :close-on-click-modal="false"
      @close="onTripEditDialogClose"
    >
      <el-form ref="tripEditFormRef" :model="tripEditForm" label-width="110px" class="trip-edit-form">
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="tripEditForm.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
            clearable
          />
        </el-form-item>

        <div class="form-row">
          <el-form-item label="开始坐标" class="form-item">
            <el-input v-model="tripEditForm.startCoord" placeholder="请选择坐标" clearable>
              <el-button slot="append" icon="el-icon-location" @click="openTripEditMapDialog('start')"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="结束坐标" class="form-item">
            <el-input v-model="tripEditForm.endCoord" placeholder="请选择坐标" clearable>
              <el-button slot="append" icon="el-icon-location" @click="openTripEditMapDialog('end')"></el-button>
            </el-input>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="开始地址" class="form-item">
            <el-input v-model="tripEditForm.startAddressDetail" placeholder="请输入开始地址" clearable />
          </el-form-item>
          <el-form-item label="结束地址" class="form-item">
            <el-input v-model="tripEditForm.endAddressDetail" placeholder="请输入结束地址" clearable />
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tripEditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTripEdit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择坐标"
      :visible.sync="tripEditMapDialogVisible"
      width="70%"
      append-to-body
      @close="onTripEditMapDialogClose"
    >
      <div class="trip-edit-map-wrap">
        <div class="trip-edit-map-search">
          <el-autocomplete
            v-model="tripEditMapSearchText"
            :fetch-suggestions="queryTripEditSearchAsync"
            placeholder="请输入位置"
            style="width: 18.75rem;"
            @select="handleTripEditMapSelect"
            @keyup.enter.native="searchTripEditMapLocation"
            popper-append-to-body
            trigger-on-focus
            :highlight-first-item="true"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchTripEditMapLocation"></el-button>
          </el-autocomplete>
        </div>
        <div ref="tripEditMapEl" class="trip-edit-map"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tripEditMapDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="正在解析地址"
      :visible.sync="exportRegeoProgressVisible"
      width="420px"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
    >
      <el-progress :percentage="exportRegeoProgress" :stroke-width="16"></el-progress>
      <p class="export-regeo-progress-label">{{ exportRegeoProgressLabel }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="cancelExportRegeo">取消导出</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="分享车辆轨迹"
      :visible.sync="trajectoryShareDialogVisible"
      width="520px"
      append-to-body
      custom-class="trajectory-share-dialog"
      @closed="resetTrajectoryShareDialog"
    >
      <div class="trajectory-share-dialog-body">
        <el-form v-if="!trajectoryShareUrl" label-position="top" size="small">
          <el-form-item label="分享范围">
            <el-radio-group v-model="trajectoryShareScope">
              <el-radio label="CURRENT_POSITION">仅当前位置</el-radio>
              <el-radio label="FULL_TRIP">完整行程</el-radio>
            </el-radio-group>
            <p class="trajectory-share-help">仅当前位置不会展示历史轨迹、播放、告警、围栏和规划路线。</p>
          </el-form-item>
          <el-form-item label="分享有效期">
            <el-input-number v-model="trajectoryShareExpiresInHours" :min="1" :max="720" :step="1" controls-position="right" />
            <span class="trajectory-share-unit">小时（最长 720 小时）</span>
          </el-form-item>
        </el-form>
        <template v-else>
        <p class="trajectory-share-success-line">
          <span>分享生成成功</span>
          <a
            v-if="trajectoryShareUrl"
            :href="trajectoryShareUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="trajectory-share-go-link"
          >点击前往</a>
        </p>
        <p class="trajectory-share-meta">分享范围：{{ trajectoryShareScope === 'FULL_TRIP' ? '完整行程' : '仅当前位置' }} · 到期时间：{{ trajectoryShareExpiresAt ? formatDate(trajectoryShareExpiresAt) : '-' }}</p>
        <div class="trajectory-share-url-row">
          <el-input
            v-model="trajectoryShareUrl"
            type="textarea"
            :rows="3"
            readonly
            placeholder="分享链接"
            class="trajectory-share-url-input"
          />
          <el-button type="primary" plain @click="copyTrajectoryShareUrl">点击复制</el-button>
        </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="!trajectoryShareUrl">
          <el-button @click="trajectoryShareDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="trajectoryShareSubmitting" v-permission="'waybill:share'" @click="createTrajectoryShare">生成分享</el-button>
        </template>
        <el-button v-else type="danger" plain :loading="trajectoryShareRevoking" v-permission="'waybill:share'" @click="revokeTrajectoryShare">撤销分享</el-button>
        <el-button v-if="trajectoryShareUrl" @click="trajectoryShareDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 导入坐标转换工具
import coordtransform from '@/WGS84.js';

import html2canvas from 'html2canvas';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { buildAmapStaticMapUrlFromTrackPoints } from '@/utils/amapStaticMap';
import { setAmapSecurityConfig, loadAmapSDK } from '@/utils/amapConfig';
import { tiandituDecodeCoordsSequential, tiandituDecodeCoordsConcurrent } from '@/utils/tiandituGeocoder';
import { Screenshot } from '@amap/screenshot';
import SpeedCurvePanel from '@/components/SpeedCurvePanel.vue';
import playbackRangeMixin from '@/mixins/playbackRangeMixin';
import { buildSpeedChartPoints, handleSpeedCurvePointClick } from '@/utils/speedChartPoints';

/* global AMap */

// 全局坐标地址缓存（跨组件共享，保证“结束位置/最后位置/停车点”一致）
const GLOBAL_COORD_ADDRESS_CACHE_KEY = '__GLOBAL_COORD_ADDRESS_MAP__';

function getGlobalCoordAddressCache() {
  if (typeof window === 'undefined') return new Map();
  if (!(window[GLOBAL_COORD_ADDRESS_CACHE_KEY] instanceof Map)) {
    window[GLOBAL_COORD_ADDRESS_CACHE_KEY] = new Map();
  }
  return window[GLOBAL_COORD_ADDRESS_CACHE_KEY];
}

/** 与 TransportService.lonLatToGcj02 一致，保证折线与车标坐标同源 */
function lonLatToGcjLikeTransport(lon, lat) {
  const nlon = Number(lon)
  const nlat = Number(lat)
  if (Number.isNaN(nlon) || Number.isNaN(nlat)) return [0, 0]
  const useScaled = Math.max(Math.abs(nlon), Math.abs(nlat)) > 10000
  if (useScaled) {
    const lonWgs84 = nlon / 600000.0
    const latWgs84 = nlat / 600000.0
    return coordtransform.wgs84togcj02(lonWgs84, latWgs84)
  }
  return [nlon, nlat]
}

/** runRoute 原始 lon/lat → WGS84 十进制度（与历史轨迹页 ×600000 规则一致） */
function runRoutePointToWgsDeg(lon, lat) {
  const nlon = Number(lon)
  const nlat = Number(lat)
  if (!Number.isFinite(nlon) || !Number.isFinite(nlat)) return [0, 0]
  const useScaled = Math.max(Math.abs(nlon), Math.abs(nlat)) > 10000
  if (useScaled) {
    return [nlon / 600000, nlat / 600000]
  }
  return [nlon, nlat]
}

/** 与轨迹 info 一致：相邻点计算角度（正北 0°，顺时针） */
function calcAngle(a, b) {
  if (!a || !b) return null
  const aLon = Number(a.longitude)
  const aLat = Number(a.latitude)
  const bLon = Number(b.longitude)
  const bLat = Number(b.latitude)
  if (![aLon, aLat, bLon, bLat].every(Number.isFinite)) return null
  let dRotateAngle = Math.atan2(Math.abs(aLon - bLon), Math.abs(aLat - bLat))
  if (bLon >= aLon) {
    if (!(bLat >= aLat)) {
      dRotateAngle = Math.PI - dRotateAngle
    }
  } else if (bLat >= aLat) {
    dRotateAngle = 2 * Math.PI - dRotateAngle
  } else {
    dRotateAngle = Math.PI + dRotateAngle
  }
  return (dRotateAngle * 180) / Math.PI
}

/** 轨迹明细：接口无方向时由相邻点推算；单点 0 */
function computeTrackRowHeadingDeg(runRoute, index) {
  const n = runRoute.length
  if (n <= 1) return 0
  if (index < n - 1) {
    const a = runRoutePointToWgsDeg(runRoute[index].lon, runRoute[index].lat)
    const b = runRoutePointToWgsDeg(runRoute[index + 1].lon, runRoute[index + 1].lat)
    const deg = calcAngle(
      { longitude: a[0], latitude: a[1] },
      { longitude: b[0], latitude: b[1] }
    )
    return Number.isFinite(deg) ? Math.round(deg) : 0
  }
  const a = runRoutePointToWgsDeg(runRoute[index - 1].lon, runRoute[index - 1].lat)
  const b = runRoutePointToWgsDeg(runRoute[index].lon, runRoute[index].lat)
  const deg = calcAngle(
    { longitude: a[0], latitude: a[1] },
    { longitude: b[0], latitude: b[1] }
  )
  return Number.isFinite(deg) ? Math.round(deg) : 0
}

/** 正北 0°、顺时针角度 → 八方位字 */
function headingDegToCardinal8(deg) {
  const d = ((Number(deg) % 360) + 360) % 360
  if (d <= 22.5 || d > 337.5) return '北'
  if (d <= 67.5) return '东北'
  if (d <= 112.5) return '东'
  if (d <= 157.5) return '东南'
  if (d <= 202.5) return '南'
  if (d <= 247.5) return '西南'
  if (d <= 292.5) return '西'
  return '西北'
}

/** 轨迹明细展示：角度或已有方位字面 → 八方位 */
function directionToCardinal8(v) {
  if (['北', '东北', '东', '东南', '南', '西南', '西', '西北'].includes(v)) return v
  if (v != null && v !== '' && Number.isFinite(Number(v))) return headingDegToCardinal8(Number(v))
  return '北'
}

/** runRoute 点 gtm（yyyymmdd/hhmmss）→ 毫秒时间戳，供轨迹时间轴插值 */
function parseGtmToMs(gtm) {
  if (!gtm || String(gtm).length < 15) return null;
  try {
    const datePart = gtm.substring(0, 8);
    const timePart = gtm.substring(9);
    const year = datePart.substring(0, 4);
    const month = datePart.substring(4, 6);
    const day = datePart.substring(6, 8);
    const hour = timePart.substring(0, 2);
    const minute = timePart.substring(2, 4);
    const second = timePart.substring(4, 6);
    const d = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    const t = d.getTime();
    return Number.isNaN(t) ? null : t;
  } catch (e) {
    return null;
  }
}

/** visualRoute 的 runRoute 点速度（km/h）：读 spd，并兼容大小写/别名与字符串中的数字 */
function parseRunRouteSpdKm(item) {
  if (!item || typeof item !== 'object') return 0
  const raw =
    item.spd != null && item.spd !== ''
      ? item.spd
      : item.SPD != null && item.SPD !== ''
        ? item.SPD
        : item.speed != null && item.speed !== ''
          ? item.speed
          : item.Speed != null && item.Speed !== ''
            ? item.Speed
            : null
  if (raw === null || raw === undefined || raw === '') return 0
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : 0
  const s = String(raw).trim().replace(/,/g, '')
  const m = s.match(/-?\d+(?:\.\d+)?/)
  if (!m) return 0
  const n = parseFloat(m[0])
  return Number.isFinite(n) ? n : 0
}

export default {
  name: 'RightDataNew',
  mixins: [playbackRangeMixin],
  components: {
    SpeedCurvePanel
  },
  props: {
    qualityMode: { type: Boolean, default: false },
    independentExportHandler: { type: Function, default: null },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isExpandedNum: {
      type: Number,
      default: 2
    },
    initialActiveTab: {
      type: String,
      default: 'first'
    },
    captureActive: {
      type: Boolean,
      default: false
    },
    runRoute: {
      type: Array,
      default: () => []
    },
    parkingData: {
      type: Array,
      default: () => []
    },
    tripSummary: {
      type: Object,
      default: () => ({
        distance: '0km',
        duration: '0时0分0秒'
      })
    },
    /** 父组件已创建 AMapUI PathNavigator，车标由 navg 驱动 */
    pathNavigatorActive: {
      type: Boolean,
      default: false
    },
    trajectoryShareEnabled: {
      type: Boolean,
      default: false
    },
    trajectoryShareHandler: {
      type: Function,
      default: null
    },
    trajectoryShareRevokeHandler: {
      type: Function,
      default: null
    },
    /** 父组件传入的车牌号。 */
    plateFromApi: {
      type: String,
      default: ''
    },
    /**
     * 有「查询」按钮时：父组件把“当前查询表单/输入框”的车牌直接传进来，
     * 行程条头部优先展示它；仅在为空时才回退 localStorage / 接口数据。
     */
    plateFromQuery: {
      type: String,
      default: ''
    },
    /**
     * 仅用于展示覆盖（不改变轨迹点）：起止时间/经纬度/地址
     * { start:{time,lon,lat,location}, end:{time,lon,lat,location} }
     */
    displayOverride: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // 视频播放器
      videoProgress: 0,
      playbackSpeed: '20',
      speedMenuOpen: false,
      speedOptions: [
        { label: 'x1', value: '1' },
        { label: 'x5', value: '5' },
        { label: 'x10', value: '10' },
        { label: 'x20', value: '20' },
        { label: 'x50', value: '50' }
      ],
      // 标签页
      activeTab: this.initialActiveTab || 'first',
      // 轨迹数据（默认值，当 runRoute 为空时使用）
      trackData: [],
      // 位置缓存，避免重复调用逆地理编码
      locationCache: {},
      // 行程信息显示状态
      showTripInfo: false,
      // 停靠点分页
      parkingPageNum: 1,
      parkingPageSize: 20,
      // 轨迹分页
      trackPageNum: 1,
      trackPageSize: 20,
      // 播放状态
      isPlaying: false,
      /** 当前播放到第几秒（可小数），相对轨迹起点 */
      playElapsedSeconds: 0,
      playInterval: null,
      vehicleMarker: null,
      sliderDragging: false,
      /** 为 true 时忽略 Slider 因 v-model 回写触发的 @input，避免误判为拖动导致播放卡死 */
      suppressSliderSeek: false,
      /** 点击轨迹数据点预览：车标临时跳到该点，playElapsedSeconds 不变 */
      trackPointPreviewActive: false,
      // 时间相关
      currentTime: '00:00:00',
      totalTime: '00:00:00',
      exportDialogVisible: false,
      exporting: false,
      exportOptionParkingOnly: false,
      exportOptionFull: true,
      exportRegeoProgressVisible: false,
      exportRegeoProgress: 0,
      exportRegeoProgressLabel: '',
      exportCancelRequested: false,
      trajectoryShareDialogVisible: false,
      trajectoryShareUrl: '',
      trajectoryShareSubmitting: false,
      trajectoryShareRevoking: false,
      trajectoryShareId: '',
      trajectoryShareScope: 'FULL_TRIP',
      trajectoryShareExpiresInHours: 72,
      trajectoryShareExpiresAt: '',
      tripEditDialogVisible: false,
      /** 打开「修正地址」弹窗时的表单快照，用于判断是否改动时间/坐标/地址 */
      tripEditOpenSnapshot: null,
      tripEditForm: {
        timeRange: null,
        startCoord: '',
        endCoord: '',
        startAddressDetail: '',
        endAddressDetail: '',
        startLocationRaw: '',
        endLocationRaw: ''
      },
      tripEditMapDialogVisible: false,
      tripEditMapTarget: 'start',
      tripEditMapSearchText: '',
      tripEditMapInstance: null,
      tripEditMapInitPromise: null,
      /** 行程起终点逆地理重试定时器（成功或组件销毁时清除） */
      tripEndpointResolveTimerStart: null,
      tripEndpointResolveTimerEnd: null
    }
  },
  computed: {
    qualityTimeGaps() {
      const points = this.processedTrackData
      if (!this.qualityMode || points.length < 2) return []
      const start = points[0].timeMs
      const duration = points[points.length - 1].timeMs - start
      if (duration <= 0) return []
      return points.flatMap((point, index) => index && point.segmentKey !== points[index - 1].segmentKey ? [{ key: point.pointKey, left: (points[index - 1].timeMs - start) / duration * 100, width: (point.timeMs - points[index - 1].timeMs) / duration * 100, seconds: (point.timeMs - points[index - 1].timeMs) / 1000 }] : [])
    },
    fallbackPlateFromData() {
      const route = Array.isArray(this.sourceRoute) ? this.sourceRoute : []
      if (route.length) {
        const first = route[0] || {}
        const v = first.vclN != null ? String(first.vclN).trim() : first.vno != null ? String(first.vno).trim() : ''
        if (v) return v
      }
      return ''
    },
    // 获取车牌号（无覆盖时用于导出等）
    licensePlate() {
      const fromQuery = this.plateFromQuery != null ? String(this.plateFromQuery).trim() : ''
      const fromApi = this.plateFromApi != null ? String(this.plateFromApi).trim() : ''
      return fromQuery || fromApi || this.fallbackPlateFromData
    },
    /** 行程条、导出和定位展示用的车牌。 */
    plateForTripHeader() {
      return this.licensePlate
    },
    tripInfoHeaderDisplay() {
      return this.plateForTripHeader || '—'
    },
    /** 定位到地图时的主展示编号（与头部一致） */
    mapLocatePrimaryId() {
      return this.plateForTripHeader || ''
    },
    // 处理轨迹数据
    processedTrackData() {
      if (!this.runRoute || this.runRoute.length === 0) {
        return this.trackData;
      }

      return this.runRoute.map((item, index) => {
        const [lonGcj02, latGcj02] = lonLatToGcjLikeTransport(item.lon, item.lat);
        const coordKey = `${lonGcj02.toFixed(6)},${latGcj02.toFixed(6)}`;

        // 格式化 GPS 时间
        let time = '';
        if (item.gtm) {
          // 格式: "yyyymmdd/hhmmss" -> "yyyy-MM-dd hh:mm:ss"
          const datePart = item.gtm.substring(0, 8);
          const timePart = item.gtm.substring(9);
          if (datePart && timePart) {
            const year = datePart.substring(0, 4);
            const month = datePart.substring(4, 6);
            const day = datePart.substring(6, 8);
            const hour = timePart.substring(0, 2);
            const minute = timePart.substring(2, 4);
            const second = timePart.substring(4, 6);
            time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
          }
        }

        const spdNum = this.qualityMode ? (item.spd != null && Number.isFinite(Number(item.spd)) && Number(item.spd) >= 0 ? Number(item.spd) : null) : parseRunRouteSpdKm(item)
        const hgtRaw = item.hgt
        const hgt =
          hgtRaw != null && hgtRaw !== '' && Number.isFinite(Number(hgtRaw)) ? Number(hgtRaw) : 0
        let agl =
          item.agl != null && item.agl !== '' && Number.isFinite(Number(item.agl))
            ? Math.round(Number(item.agl))
            : null
        if (agl == null) {
          agl = computeTrackRowHeadingDeg(this.runRoute, index)
        }
        const aglCardinal = directionToCardinal8(agl)
        // 构建轨迹数据
        const trackItem = {
          pointKey: item.pointKey,
          rawSpeed: this.qualityMode ? item.rawSpeed : null,
          quality: this.qualityMode ? item.quality || [] : [],
          pointIndex: index,
          wgsLongitude: this.qualityMode ? item.wgsLongitude : null,
          wgsLatitude: this.qualityMode ? item.wgsLatitude : null,
          qualityText: this.qualityMode ? (item.quality || []).map(value => ({ UNKNOWN_SPEED: '速度未知', INVALID_SPEED: '速度非法', OVERSPEED: '超速', GAP_BEFORE: '前段缺报' }[value] || value)).join('、') : '',
          waybillNo: item.waybillNo,
          segmentKey: item.segmentKey,
          time: time,
          timeMs: this.qualityMode ? item.locationTime : parseGtmToMs(item.gtm),
          location: (this.qualityMode && item.address) || this.locationCache[coordKey] || '鼠标移上获取位置...', // 从缓存中获取位置信息
          coordinate: `${lonGcj02.toFixed(6)}, ${latGcj02.toFixed(6)}`,
          speed: this.qualityMode && spdNum == null ? (item.rawSpeed ? `非法(${item.rawSpeed})` : '未知') : `${spdNum}km/h`,
          spdNum,
          hgt,
          roadLimit: item.mspd != null ? item.mspd : item.maxSpd,
          lon: lonGcj02,
          lat: latGcj02,
          mil: item.mil != null ? item.mil : null,
          agl: aglCardinal
        };

        return trackItem;
      });
    },
    speedChartPoints() {
      if (this.qualityMode) return this.rangeFilteredTrackData.map(point => ({ ...point, speed: point.spdNum, trackIndex: this.processedTrackData.findIndex(item => item.pointKey === point.pointKey) }))
      return buildSpeedChartPoints(this.rangeFilteredTrackData)
    },
    fullSpeedChartPoints() {
      if (this.qualityMode) return this.processedTrackData.map((point, index) => ({ ...point, speed: point.spdNum, trackIndex: index }))
      return buildSpeedChartPoints(this.processedTrackData)
    },
    // 处理停靠点数据
    parkingDataIdentity() {
      return JSON.stringify((this.parkingData || []).map(item => [item.waybillNo, item.startTime, item.endTime, item.lon, item.lat]))
    },
    processedParkingData() {
      // 如果有通过 props 传递的 parkingData，使用它
      if (this.parkingData && this.parkingData.length > 0) {
        return this.parkingData.map(item => {
          const [lonGcj02, latGcj02] = lonLatToGcjLikeTransport(item.lon, item.lat);
          const coordKey = `${lonGcj02.toFixed(6)},${latGcj02.toFixed(6)}`;

          // 构建停靠点数据
          const presetLoc =
            item.location != null && String(item.location).trim() !== ''
              ? String(item.location).trim()
              : '';
          const parkingItem = {
            ...item,
            lon: lonGcj02,
            lat: latGcj02,
            // 历史轨迹插件接口已带 parkAdr 时优先展示；运输规划页仍为空串则走悬停逆地理
            location: (this.qualityMode && presetLoc) || this.locationCache[coordKey] || presetLoc || '鼠标移上获取位置...'
          };

          return parkingItem;
        });
      }
      // 如果没有 parkingData，返回默认数据
      return [];
    },

    // 停靠点当前页数据
    currentParkingData() {
      const start = (this.parkingPageNum - 1) * this.parkingPageSize;
      const end = start + this.parkingPageSize;
      return this.rangeFilteredParkingData.slice(start, end);
    },
    // 轨迹当前页数据
    currentTrackData() {
      const start = (this.trackPageNum - 1) * this.trackPageSize;
      const end = start + this.trackPageSize;
      return this.rangeFilteredTrackData.slice(start, end);
    },
    // 行程开始信息
    tripStartInfo() {
      const trackData = this.rangeFilteredTrackData;
      const raw = trackData && trackData.length > 0 ? trackData[0] : null
      if (!raw) return null
      const o = this.displayOverride && this.displayOverride.start ? this.displayOverride.start : null
      if (!o) return raw
      const lon =
        o.lon != null && o.lon !== '' && String(o.lon).trim() !== ''
          ? Number(o.lon)
          : NaN
      const lat =
        o.lat != null && o.lat !== '' && String(o.lat).trim() !== ''
          ? Number(o.lat)
          : NaN
      return {
        ...raw,
        time: o.time != null && String(o.time).trim() !== '' ? String(o.time).trim() : raw.time,
        lon: Number.isFinite(lon) ? lon : raw.lon,
        lat: Number.isFinite(lat) ? lat : raw.lat,
        location:
          o.location != null && String(o.location).trim() !== ''
            ? String(o.location).trim()
            : raw.location
      }
    },
    // 行程结束信息
    tripEndInfo() {
      const trackData = this.rangeFilteredTrackData;
      const raw = trackData && trackData.length > 0 ? trackData[trackData.length - 1] : null
      if (!raw) return null
      const o = this.displayOverride && this.displayOverride.end ? this.displayOverride.end : null
      if (!o) return raw
      const lon =
        o.lon != null && o.lon !== '' && String(o.lon).trim() !== ''
          ? Number(o.lon)
          : NaN
      const lat =
        o.lat != null && o.lat !== '' && String(o.lat).trim() !== ''
          ? Number(o.lat)
          : NaN
      return {
        ...raw,
        time: o.time != null && String(o.time).trim() !== '' ? String(o.time).trim() : raw.time,
        lon: Number.isFinite(lon) ? lon : raw.lon,
        lat: Number.isFinite(lat) ? lat : raw.lat,
        location:
          o.location != null && String(o.location).trim() !== ''
            ? String(o.location).trim()
            : raw.location
      }
    },
    /** 行程条地址展示：未解析成功时不显示「鼠标移上…」等占位文案 */
    tripStartLocationDisplay() {
      if (!this.tripStartInfo) return '暂无数据'
      const loc = this.tripStartInfo.location
      if (loc == null || String(loc).trim() === '') return '暂无数据'
      const t = String(loc).trim()
      if (!this.isValidResolvedAddress(t)) return '暂无数据'
      return t
    },
    tripEndLocationDisplay() {
      if (!this.tripEndInfo) return '暂无数据'
      const loc = this.tripEndInfo.location
      if (loc == null || String(loc).trim() === '') return '暂无数据'
      const t = String(loc).trim()
      if (!this.isValidResolvedAddress(t)) return '暂无数据'
      return t
    },
    /** 轨迹可播放总时长（秒）：优先用首尾 gtm 时间差，否则退化为「点数-1」与旧逻辑一致 */
    trackPlaybackTotalSeconds() {
      const pts = this.processedTrackData;
      if (!pts || pts.length < 2) return 0;
      const all = pts.every((p) => p.timeMs != null);
      if (all) {
        const spanSec = (pts[pts.length - 1].timeMs - pts[0].timeMs) / 1000;
        if (spanSec > 1e-3) return spanSec;
      }
      return Math.max(pts.length - 1, 0);
    },
    /** 按播放进度与总里程估算已行驶距离（与进度条、时间联动） */
    playedDistanceStr() {
      const total = this.trackPlaybackTotalSeconds;
      if (total <= 0 || !this.displayTripSummary || !this.displayTripSummary.distance) return '0km';
      const ratio = Math.min(1, Math.max(0, this.playElapsedSeconds / total));
      const m = String(this.displayTripSummary.distance).match(/([\d.]+)/);
      const totalKm = m ? parseFloat(m[1]) : 0;
      return `${(totalKm * ratio).toFixed(2)}km`;
    }
  },
  watch: {
    /** 父组件切换为 PathNavigator 后，子组件不应再持有插值车标引用，避免双车标逻辑混乱 */
    pathNavigatorActive(val) {
      if (val) {
        this.vehicleMarker = null;
      }
    },
    // 监听播放速度变化：仅重建定时器，避免暂停再播的顿挫
    playbackSpeed() {
      if (this.pathNavigatorActive) {
        this.$emit('path-nav-control', { type: 'speed', speedMult: parseInt(this.playbackSpeed, 10) || 1 })
        return
      }
      if (this.isPlaying) {
        this.schedulePlayInterval();
      }
    },
    // 监听 runRoute 变化：重置播放并与新轨迹对齐
    runRoute: {
      handler(newVal, oldVal) {
        if (this.runRoutePlaybackSignature(newVal) === this.runRoutePlaybackSignature(oldVal)) return;
        this.resetTrajectoryPlayback();
        if (newVal && newVal.length > 0) {
          this.showTripInfo = true;
          this.resolveTripStartEndLocation();
          this.resolveCurrentPageLocation();
        } else {
          this.showTripInfo = false;
          this.clearTripEndpointResolveTimers();
        }
      },
      deep: true
    },
    // 停车集合变化才回首页，异步补全地址不改变分页。
    parkingDataIdentity: {
      handler() {
        this.parkingPageNum = 1;
        this.resolveCurrentPageLocation();
      }
    },
    // 监听分页变化，解析当前页数据
    parkingPageNum() {
      this.resolveCurrentPageLocation();
    },
    parkingPageSize() {
      this.resolveCurrentPageLocation();
    },
    trackPageNum() {
      this.resolveCurrentPageLocation();
    },
    trackPageSize() {
      this.resolveCurrentPageLocation();
    },
  },
  created() {
    // 独立页在查询成功后才挂载，初始轨迹不会触发runRoute监听。
    if (this.qualityMode) this.syncTotalTime()
  },
  beforeDestroy() {
    document.removeEventListener('click', this._speedMenuDocHandler);
    this.clearTripEndpointResolveTimers();
    if (this.playInterval) {
      clearInterval(this.playInterval);
      this.playInterval = null;
    }
    if (this.tripEditMapInstance) {
      try {
        this.tripEditMapInstance.destroy()
      } catch (e) {
        /* ignore */
      }
      this.tripEditMapInstance = null
    }
  },
  methods: {
    runRoutePlaybackSignature(route) {
      if (!Array.isArray(route) || !route.length) return '';
      return route.map(item => `${this.qualityMode ? item.pointKey || '' : ''}|${item.gtm || ''}|${item.lon}|${item.lat}`).join(';');
    },
    parseCoordText(coordText) {
      if (coordText == null || String(coordText).trim() === '') return null
      const parts = String(coordText).trim().split(/[,，\s]+/).map((x) => Number(x))
      if (parts.length < 2 || !Number.isFinite(parts[0]) || !Number.isFinite(parts[1])) return null
      return [parts[0], parts[1]]
    },
    formatCoordText(lon, lat) {
      const nlon = Number(lon)
      const nlat = Number(lat)
      if (!Number.isFinite(nlon) || !Number.isFinite(nlat)) return ''
      return `${nlon.toFixed(6)},${nlat.toFixed(6)}`
    },
    serializeTripEditTimeRange(tr) {
      if (!Array.isArray(tr) || tr.length < 2) {
        return JSON.stringify(['', ''])
      }
      return JSON.stringify([
        String(tr[0] != null ? tr[0] : '').trim(),
        String(tr[1] != null ? tr[1] : '').trim(),
      ])
    },
    captureTripEditOpenSnapshot() {
      const tr = this.tripEditForm.timeRange
      this.tripEditOpenSnapshot = {
        timeRange: this.serializeTripEditTimeRange(tr),
        startCoord: String(this.tripEditForm.startCoord || '').trim(),
        endCoord: String(this.tripEditForm.endCoord || '').trim(),
        startAddressDetail: String(
          this.tripEditForm.startAddressDetail || ''
        ).trim(),
        endAddressDetail: String(this.tripEditForm.endAddressDetail || '').trim(),
      }
    },
    async ensureTripEditMapLoaded() {
      if (this.tripEditMapInstance) return
      if (this.tripEditMapInitPromise) {
        await this.tripEditMapInitPromise
        return
      }
      this.tripEditMapInitPromise = (async () => {
        await this.$nextTick()
        const container = this.$refs.tripEditMapEl
        if (!container) throw new Error('地图容器未就绪')
        setAmapSecurityConfig()
        await loadAmapSDK(['AMap.Geocoder', 'AMap.AutoComplete'])
        const center = this.parseCoordText(this.tripEditForm.startCoord) || [116.404, 39.915]
        this.tripEditMapInstance = new AMap.Map(container, {
          zoom: 11,
          center,
          resizeEnable: true
        })
        this.tripEditMapInstance.on('click', (e) => {
          const lon = e && e.lnglat ? e.lnglat.getLng() : NaN
          const lat = e && e.lnglat ? e.lnglat.getLat() : NaN
          if (!Number.isFinite(lon) || !Number.isFinite(lat)) return
          const coordText = this.formatCoordText(lon, lat)
          if (this.tripEditMapTarget === 'end') {
            this.tripEditForm.endCoord = coordText
          } else {
            this.tripEditForm.startCoord = coordText
          }
          try {
            this.tripEditMapInstance.clearMap()
            new AMap.Marker({ position: [lon, lat], map: this.tripEditMapInstance })
          } catch (err) {
            /* ignore */
          }
        })
      })()
      try {
        await this.tripEditMapInitPromise
      } finally {
        this.tripEditMapInitPromise = null
      }
    },
    async openTripEditMapDialog(target) {
      this.tripEditMapTarget = target === 'end' ? 'end' : 'start'
      this.tripEditMapDialogVisible = true
      await this.$nextTick()
      try {
        await this.ensureTripEditMapLoaded()
        if (!this.tripEditMapInstance) return
        const coord = this.tripEditMapTarget === 'end'
          ? this.parseCoordText(this.tripEditForm.endCoord)
          : this.parseCoordText(this.tripEditForm.startCoord)
        if (coord) {
          this.tripEditMapInstance.setCenter(coord)
          this.tripEditMapInstance.clearMap()
          new AMap.Marker({ position: coord, map: this.tripEditMapInstance })
        }
        this.tripEditMapInstance.resize()
      } catch (e) {
        this.$message.warning('地图加载失败，请重试')
      }
    },
    onTripEditMapDialogClose() {
      if (!this.tripEditMapInstance) return
      try {
        this.tripEditMapInstance.clearMap()
      } catch (e) {
        /* ignore */
      }
    },
    queryTripEditSearchAsync(queryString, callback) {
      if (!queryString || !window.AMap) {
        callback([])
        return
      }
      AMap.plugin('AMap.AutoComplete', () => {
        this.performTripEditSearch(queryString, callback)
      })
    },
    performTripEditSearch(queryString, callback) {
      if (!window.AMap) {
        callback([])
        return
      }
      const auto = new AMap.AutoComplete({
        city: '全国',
        citylimit: false
      })
      auto.search(queryString, (status, result) => {
        if (status === 'complete' && result && result.info === 'OK' && result.tips) {
          const suggestions = result.tips
            .filter((tip) => tip && tip.location)
            .map((tip) => ({
              value: tip.name,
              address: `${tip.district || ''}${tip.address || ''}`,
              location: tip.location
            }))
            .slice(0, 10)
          callback(suggestions)
          return
        }
        callback([])
      })
    },
    handleTripEditMapSelect(item) {
      this.tripEditMapSearchText = item && item.value ? item.value : ''
      if (!item || !item.location || !this.tripEditMapInstance) return
      let lng = NaN
      let lat = NaN
      if (typeof item.location === 'string') {
        const coords = item.location.split(',')
        lng = parseFloat(coords[0])
        lat = parseFloat(coords[1])
      } else {
        lng = Number(item.location.lng)
        lat = Number(item.location.lat)
      }
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
      this.tripEditMapInstance.setCenter([lng, lat])
      this.tripEditMapInstance.setZoom(15)
      this.tripEditMapInstance.clearMap()
      new AMap.Marker({
        position: [lng, lat],
        title: item.value || '',
        map: this.tripEditMapInstance
      })
      const coordText = this.formatCoordText(lng, lat)
      if (this.tripEditMapTarget === 'end') {
        this.tripEditForm.endCoord = coordText
      } else {
        this.tripEditForm.startCoord = coordText
      }
    },
    searchTripEditMapLocation() {
      if (!this.tripEditMapSearchText || !window.AMap || !this.tripEditMapInstance) return
      const geocoder = new AMap.Geocoder({})
      geocoder.getLocation(this.tripEditMapSearchText, (status, result) => {
        if (status === 'complete' && result && result.geocodes && result.geocodes.length > 0) {
          const location = result.geocodes[0].location
          const lng = location.getLng()
          const lat = location.getLat()
          this.tripEditMapInstance.setCenter([lng, lat])
          this.tripEditMapInstance.setZoom(15)
          this.tripEditMapInstance.clearMap()
          new AMap.Marker({
            position: [lng, lat],
            title: this.tripEditMapSearchText,
            map: this.tripEditMapInstance
          })
          const coordText = this.formatCoordText(lng, lat)
          if (this.tripEditMapTarget === 'end') {
            this.tripEditForm.endCoord = coordText
          } else {
            this.tripEditForm.startCoord = coordText
          }
          return
        }
        this.$message.warning('未找到该位置')
      })
    },
    openTripEditDialog() {
      this.tripEditForm = {
        timeRange: null,
        startCoord: '',
        endCoord: '',
        startAddressDetail: '',
        endAddressDetail: '',
        startLocationRaw: '',
        endLocationRaw: '',
      }
      this.tripEditDialogVisible = true
      this.$nextTick(() => {
        const f = this.$refs.tripEditFormRef
        if (f && typeof f.clearValidate === 'function') f.clearValidate()
        this.captureTripEditOpenSnapshot()
      })
    },
    onTripEditDialogClose() {
      // 每次打开已重置为空，此处无需再清
    },
    async confirmTripEdit() {
      const snap = this.tripEditOpenSnapshot || {}
      const snapTrNorm = snap.timeRange || this.serializeTripEditTimeRange(null)
      const curTr = this.tripEditForm.timeRange
      const curTrNorm = this.serializeTripEditTimeRange(curTr)
      const timeUnchanged = curTrNorm === snapTrNorm

      const startFb = this.tripStartInfo || {}
      const endFb = this.tripEndInfo || {}

      const curStartParsed = this.parseCoordText(this.tripEditForm.startCoord)
      const curEndParsed = this.parseCoordText(this.tripEditForm.endCoord)
      const hasStartCoord = !!(
        curStartParsed &&
        Number.isFinite(curStartParsed[0]) &&
        Number.isFinite(curStartParsed[1])
      )
      const hasEndCoord = !!(
        curEndParsed &&
        Number.isFinite(curEndParsed[0]) &&
        Number.isFinite(curEndParsed[1])
      )

      let startLon
      let startLat
      if (hasStartCoord) {
        startLon = curStartParsed[0]
        startLat = curStartParsed[1]
      } else {
        startLon = Number(startFb.lon)
        startLat = Number(startFb.lat)
      }
      let endLon
      let endLat
      if (hasEndCoord) {
        endLon = curEndParsed[0]
        endLat = curEndParsed[1]
      } else {
        endLon = Number(endFb.lon)
        endLat = Number(endFb.lat)
      }

      let startTime = ''
      let endTime = ''
      if (timeUnchanged) {
        startTime = startFb.time != null ? String(startFb.time).trim() : ''
        endTime = endFb.time != null ? String(endFb.time).trim() : ''
      } else {
        const tr = Array.isArray(curTr) && curTr.length >= 2 ? curTr : []
        startTime = tr[0] != null ? String(tr[0]).trim() : ''
        endTime = tr[1] != null ? String(tr[1]).trim() : ''
      }

      const addrS =
        this.tripEditForm.startAddressDetail != null
          ? String(this.tripEditForm.startAddressDetail).trim()
          : ''
      const addrE =
        this.tripEditForm.endAddressDetail != null
          ? String(this.tripEditForm.endAddressDetail).trim()
          : ''

      /** 有经纬度：展示地址优先逆地理；无经纬度仅有起止地址：直接用输入地址 */
      let startLocation = ''
      if (hasStartCoord) {
        const geo = await this.resolveAddressByCoord(
          startLon,
          startLat,
          this.formatCoordText(startLon, startLat)
        )
        let g = geo != null ? String(geo).trim() : ''
        if (this.isValidResolvedAddress(g) && g !== '未知位置') {
          startLocation = g
        } else {
          startLocation =
            addrS ||
            (startFb.location != null ? String(startFb.location).trim() : '')
        }
      } else if (addrS) {
        startLocation = addrS
      } else {
        startLocation =
          startFb.location != null ? String(startFb.location).trim() : ''
      }

      let endLocation = ''
      if (hasEndCoord) {
        const geo = await this.resolveAddressByCoord(
          endLon,
          endLat,
          this.formatCoordText(endLon, endLat)
        )
        let g = geo != null ? String(geo).trim() : ''
        if (this.isValidResolvedAddress(g) && g !== '未知位置') {
          endLocation = g
        } else {
          endLocation =
            addrE ||
            (endFb.location != null ? String(endFb.location).trim() : '')
        }
      } else if (addrE) {
        endLocation = addrE
      } else {
        endLocation =
          endFb.location != null ? String(endFb.location).trim() : ''
      }

      const payload = {
        start: {
          time: startTime,
          lon: Number.isFinite(startLon) ? startLon : null,
          lat: Number.isFinite(startLat) ? startLat : null,
          location: startLocation,
        },
        end: {
          time: endTime,
          lon: Number.isFinite(endLon) ? endLon : null,
          lat: Number.isFinite(endLat) ? endLat : null,
          location: endLocation,
        },
      }
      this.$emit('update-display-override', payload)
      this.tripEditDialogVisible = false
    },
    formatTrackDirectionCell(row, column, cellValue) {
      return directionToCardinal8(cellValue)
    },
    _speedMenuDocHandler(e) {
      if (!this.speedMenuOpen) return;
      const root = this.$refs.speedPicker;
      if (root && !root.contains(e.target)) {
        this.speedMenuOpen = false;
        document.removeEventListener('click', this._speedMenuDocHandler);
      }
    },
    toggleSpeedMenu(e) {
      if (e) e.stopPropagation();
      const willOpen = !this.speedMenuOpen;
      this.speedMenuOpen = willOpen;
      document.removeEventListener('click', this._speedMenuDocHandler);
      if (willOpen) {
        this.$nextTick(() => {
          setTimeout(() => {
            document.addEventListener('click', this._speedMenuDocHandler);
          }, 0);
        });
      }
    },
    selectPlaybackSpeed(val) {
      this.playbackSpeed = String(val);
      this.speedMenuOpen = false;
      document.removeEventListener('click', this._speedMenuDocHandler);
    },
    /** 仅停定时器，不刷新车标（供 reset 时避免「先创建再被 destroy 掉」） */
    stopPlaybackTimer() {
      this.isPlaying = false;
      if (this.playInterval) {
        clearInterval(this.playInterval);
        this.playInterval = null;
      }
    },
    destroyVehicleMarker() {
      // PathNavigator 下车标由父组件维护；此处只清掉子组件里可能残留的引用，避免与父级车标叠两层
      if (this.pathNavigatorActive) {
        this.vehicleMarker = null;
        return;
      }
      if (this.vehicleMarker) {
        this.vehicleMarker.setMap(null);
        this.vehicleMarker = null;
      }
    },
    /**
     * 地图点击轨迹数据点：车标跳到该点预览，播放进度/进度条不变；若正在播放则暂停
     */
    seekPlaybackToRunRouteIndex(index) {
      this.previewTrackPointAtIndex(index);
    },
    previewTrackPointAtIndex(index) {
      const pts = this.processedTrackData;
      if (!pts.length || index < 0 || index >= pts.length) return;
      const p = pts[index];
      this.previewTrackPointAtPosition(p.lon, p.lat, p.bearing, index);
    },
    previewTrackPointAtPosition(lon, lat, bearing, pointIndex) {
      if (this.pathNavigatorActive) return;
      const wasPlaying = this.isPlaying;
      if (wasPlaying) {
        this.pauseTrack();
      }
      const pts = this.processedTrackData;
      let idx = pointIndex;
      if (idx == null && pts.length) {
        let best = 0;
        let bestD2 = Infinity;
        const px = Number(lon);
        const py = Number(lat);
        for (let i = 0; i < pts.length; i++) {
          const dx = Number(pts[i].lon) - px;
          const dy = Number(pts[i].lat) - py;
          const d2 = dx * dx + dy * dy;
          if (d2 < bestD2) {
            bestD2 = d2;
            best = i;
          }
        }
        idx = best;
      }
      const p = idx != null && pts[idx] ? pts[idx] : null;
      const previewLon = p ? p.lon : Number(lon);
      const previewLat = p ? p.lat : Number(lat);
      const previewBearing = p && p.bearing != null ? p.bearing : bearing;
      if (!Number.isFinite(previewLon) || !Number.isFinite(previewLat)) return;
      this.trackPointPreviewActive = true;
      if (!this.vehicleMarker) {
        this.createVehicleMarker();
      }
      if (this.vehicleMarker) {
        this.vehicleMarker.setPosition([previewLon, previewLat]);
        if (previewBearing != null) {
          this.vehicleMarker.setAngle(previewBearing);
        }
      }
      const total = this.trackPlaybackTotalSeconds;
      const ratio = total > 0 ? Math.min(1, Math.max(0, this.playElapsedSeconds / total)) : 0;
      const meta = p ? {
        displayTime: p.time || '—',
        spdKm: p.spdNum != null ? p.spdNum : 0,
        location: p.location || '—',
        hgt: p.hgt,
        roadLimit: p.roadLimit,
        status: p.status || '—'
      } : this.metaAtPlaybackElapsed(this.playElapsedSeconds);
      this.$emit('playback-progress', {
        ratio,
        playElapsedSeconds: this.playElapsedSeconds,
        totalSeconds: total,
        isPlaying: false,
        lon: previewLon,
        lat: previewLat,
        previewOnly: true,
        ...meta
      });
    },
    clearTrackPointPreview() {
      if (!this.trackPointPreviewActive) return;
      this.trackPointPreviewActive = false;
      this.applyPlaybackPosition();
    },
    currentPathNavSpeedMult() {
      return parseInt(this.playbackSpeed, 10) || 1;
    },
    emitPathNavPlay() {
      this.$emit('path-nav-control', {
        type: 'play',
        speedMult: this.currentPathNavSpeedMult()
      });
    },
    // 拖动过程：只跳转轨迹与进度，不改变 isPlaying（播放/暂停按钮保持原状态）
    onProgressInput(val) {
      if (this.suppressSliderSeek) return;
      const trackData = this.processedTrackData;
      if (!trackData.length) return;
      const dragJustStarted = !this.sliderDragging;
      this.sliderDragging = true;
      if (this.pathNavigatorActive && dragJustStarted && this.isPlaying) {
        // 正在播放时开始拖动：先暂停导航器，避免车标与滑块抢进度
        this.$emit('path-nav-control', { type: 'pause' });
      }
      if (this.pathNavigatorActive) {
        this.seekToProgress(val, { commitNavSeek: false });
      } else {
        this.seekToProgress(val);
      }
    },
    /**
     * 当前播放时刻对应的展示字段（供地图侧信息窗同步）
     */
    metaAtPlaybackElapsed(elapsedSec) {
      const pts = this.processedTrackData;
      const n = pts.length;
      if (n === 0) {
        return {
          displayTime: '—',
          spdKm: 0,
          location: '—',
          coordinate: '—',
          hgt: null,
          status: '—',
          roadLimit: '—'
        };
      }
      const total = this.trackPlaybackTotalSeconds;
      const clamped = Math.max(0, Math.min(elapsedSec, total));
      const allTime = pts.every((p) => p.timeMs != null);
      const t0 = pts[0].timeMs;
      const tEnd = pts[n - 1].timeMs;
      const useTime = allTime && t0 != null && tEnd != null && (tEnd - t0) / 1000 > 1e-3;

      let displayTime = pts[0].time || '—';
      let spdKm = pts[0].spdNum != null ? pts[0].spdNum : 0;
      let location = pts[0].location || '—';
      let hgt = pts[0].hgt;
      let roadLimit = pts[0].roadLimit;

      if (useTime) {
        const T = t0 + clamped * 1000;
        displayTime = this.formatMsToDateTime(T);
        if (T <= t0) {
          spdKm = pts[0].spdNum || 0;
          location = pts[0].location || '—';
          hgt = pts[0].hgt;
          roadLimit = pts[0].roadLimit;
        } else if (T >= tEnd) {
          spdKm = pts[n - 1].spdNum || 0;
          location = pts[n - 1].location || '—';
          hgt = pts[n - 1].hgt;
          roadLimit = pts[n - 1].roadLimit;
        } else {
          for (let i = 0; i < n - 1; i++) {
            const a = pts[i].timeMs;
            const b = pts[i + 1].timeMs;
            if (a <= T && T <= b) {
              const denom = b - a;
              const r = denom === 0 ? 0 : (T - a) / denom;
              const sa = pts[i].spdNum != null ? pts[i].spdNum : 0;
              const sb = pts[i + 1].spdNum != null ? pts[i + 1].spdNum : 0;
              spdKm = sa + r * (sb - sa);
              location = r < 0.5 ? (pts[i].location || '—') : (pts[i + 1].location || '—');
              const ha = pts[i].hgt;
              const hb = pts[i + 1].hgt;
              if (ha != null && hb != null) hgt = ha + r * (hb - ha);
              else hgt = ha != null ? ha : hb;
              const ra = pts[i].roadLimit;
              const rb = pts[i + 1].roadLimit;
              roadLimit = ra != null ? ra : rb;
              break;
            }
          }
        }
      } else if (total > 0) {
        const ratio = clamped / total;
        const f = ratio * (n - 1);
        const i = Math.min(Math.floor(f), n - 2);
        const j = i + 1;
        const localR = f - i;
        const sa = pts[i].spdNum != null ? pts[i].spdNum : 0;
        const sb = pts[j].spdNum != null ? pts[j].spdNum : 0;
        spdKm = sa + localR * (sb - sa);
        displayTime = localR < 0.5 ? (pts[i].time || '—') : (pts[j].time || '—');
        location = localR < 0.5 ? (pts[i].location || '—') : (pts[j].location || '—');
        const ha = pts[i].hgt;
        const hb = pts[j].hgt;
        if (ha != null && hb != null) hgt = ha + localR * (hb - ha);
        else hgt = ha != null ? ha : hb;
        roadLimit = pts[i].roadLimit != null ? pts[i].roadLimit : pts[j].roadLimit;
      }

      const pos = this.interpolatePositionAtElapsed(clamped);
      const coordinate = pos ? `${pos.lon.toFixed(6)}, ${pos.lat.toFixed(6)}` : '—';
      const status = spdKm > 0.5 ? '行驶/ACC开启' : '停车';
      const roadStr =
        roadLimit != null && roadLimit !== '' ? `${roadLimit}km/h` : '—';

      return {
        displayTime,
        spdKm,
        location,
        coordinate,
        hgt,
        status,
        roadLimit: roadStr
      };
    },
    formatMsToDateTime(ms) {
      const d = new Date(ms);
      if (Number.isNaN(d.getTime())) return '—';
      const y = d.getFullYear();
      const mo = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const h = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      const s = String(d.getSeconds()).padStart(2, '0');
      return `${y}-${mo}-${day} ${h}:${mi}:${s}`;
    },
    /**
     * 根据已播放秒数（相对起点）插值经纬度；优先按 gtm 时间轴，否则按点索引均匀映射
     */
    interpolatePositionAtElapsed(elapsedSec) {
      const pts = this.processedTrackData;
      const n = pts.length;
      if (n === 0) return null;
      if (n === 1) {
        return { lon: pts[0].lon, lat: pts[0].lat, bearing: 0 };
      }
      const total = this.trackPlaybackTotalSeconds;
      const clamped = Math.max(0, Math.min(elapsedSec, total));
      if (this.qualityMode && pts.some((point, index) => index && point.segmentKey !== pts[index - 1].segmentKey && pts[0].timeMs + clamped * 1000 > pts[index - 1].timeMs && pts[0].timeMs + clamped * 1000 < point.timeMs)) return null;
      const allTime = pts.every((p) => p.timeMs != null);
      const t0 = pts[0].timeMs;
      const tEnd = pts[n - 1].timeMs;
      const useTime = allTime && t0 != null && tEnd != null && (tEnd - t0) / 1000 > 1e-3;

      if (useTime) {
        const T = t0 + clamped * 1000;
        if (T <= t0) {
          return {
            lon: pts[0].lon,
            lat: pts[0].lat,
            bearing: this.calculateBearing(pts[0], pts[1])
          };
        }
        if (T >= tEnd) {
          return {
            lon: pts[n - 1].lon,
            lat: pts[n - 1].lat,
            bearing: this.calculateBearing(pts[n - 2], pts[n - 1])
          };
        }
        for (let i = 0; i < n - 1; i++) {
          const a = pts[i].timeMs;
          const b = pts[i + 1].timeMs;
          if (a <= T && T <= b) {
            const denom = b - a;
            const r = denom === 0 ? 0 : (T - a) / denom;
            const lon = pts[i].lon + r * (pts[i + 1].lon - pts[i].lon);
            const lat = pts[i].lat + r * (pts[i + 1].lat - pts[i].lat);
            const bearing = this.calculateBearing(pts[i], pts[i + 1]);
            return { lon, lat, bearing };
          }
        }
      }
      if (total <= 0) {
        return { lon: pts[0].lon, lat: pts[0].lat, bearing: n > 1 ? this.calculateBearing(pts[0], pts[1]) : 0 };
      }
      const ratio = clamped / total;
      const f = ratio * (n - 1);
      const i = Math.min(Math.floor(f), n - 2);
      const j = i + 1;
      const localR = f - i;
      const lon = pts[i].lon + localR * (pts[j].lon - pts[i].lon);
      const lat = pts[i].lat + localR * (pts[j].lat - pts[i].lat);
      const bearing = this.calculateBearing(pts[i], pts[j]);
      return { lon, lat, bearing };
    },
    // 收缩右侧监控区域
    collapsePanel(num) {
      this.$emit('collapse', num);
    },
    // 停靠点分页大小变化
    handleParkingSizeChange(val) {
      this.parkingPageSize = val;
      this.parkingPageNum = 1;
    },
    // 停靠点当前页变化
    handleParkingCurrentChange(val) {
      this.parkingPageNum = val;
    },
    // 轨迹分页大小变化
    handleTrackSizeChange(val) {
      this.trackPageSize = val;
      this.trackPageNum = 1;
    },
    // 轨迹当前页变化
    handleTrackCurrentChange(val) {
      this.trackPageNum = val;
    },
    clearTripEndpointResolveTimers() {
      if (this.tripEndpointResolveTimerStart) {
        clearTimeout(this.tripEndpointResolveTimerStart);
        this.tripEndpointResolveTimerStart = null;
      }
      if (this.tripEndpointResolveTimerEnd) {
        clearTimeout(this.tripEndpointResolveTimerEnd);
        this.tripEndpointResolveTimerEnd = null;
      }
    },
    /**
     * 行程起终点逆地理：失败则延时重试直到解析成功（与表格「悬停解析」独立，行程条不依赖鼠标）
     */
    startTripEndpointResolveLoop(lon, lat, coordKey, which) {
      const timerProp =
        which === 'start' ? 'tripEndpointResolveTimerStart' : 'tripEndpointResolveTimerEnd';
      const attemptResolve = (attempt) => {
        if (this.playbackRangeDragging) return;
        this.resolveAddressByCoord(lon, lat, coordKey)
          .then((address) => {
            if (this.isValidResolvedAddress(address)) {
              this[timerProp] = null;
              this.$forceUpdate();
              return;
            }
            const delay = Math.min(2000 + attempt * 1000, 20000);
            this[timerProp] = setTimeout(() => attemptResolve(attempt + 1), delay);
          })
          .catch(() => {
            const delay = Math.min(2000 + attempt * 1000, 20000);
            this[timerProp] = setTimeout(() => attemptResolve(attempt + 1), delay);
          });
      };
      attemptResolve(0);
    },
    // 解析行程开始和结束的位置信息
    resolveTripStartEndLocation() {
      if (this.playbackRangeDragging) return
      this.clearTripEndpointResolveTimers();
      const trackData = this.rangeFilteredTrackData;
      if (!trackData || trackData.length === 0) return;

      const startPoint = trackData[0];
      const endPoint = trackData[trackData.length - 1];
      const startCoordKey = `${startPoint.lon.toFixed(6)},${startPoint.lat.toFixed(6)}`;
      const endCoordKey = `${endPoint.lon.toFixed(6)},${endPoint.lat.toFixed(6)}`;

      if (!this.getCachedAddress(startCoordKey)) {
        this.startTripEndpointResolveLoop(startPoint.lon, startPoint.lat, startCoordKey, 'start');
      }
      if (endCoordKey !== startCoordKey && !this.getCachedAddress(endCoordKey)) {
        this.startTripEndpointResolveLoop(endPoint.lon, endPoint.lat, endCoordKey, 'end');
      }
    },
    // 解析当前页数据的位置信息（已废弃，改为按需解析）
    resolveCurrentPageLocation() {
      // 不再一页一页解析，改为鼠标悬停时按需解析
    },
    /** el-table 悬停进入单元格时解析（比 span 上 mouseenter 更可靠） */
    onParkingTableCellEnter(row, column) {
      if (column && column.label === '停车位置') {
        this.resolveParkingLocation(row);
      }
    },
    onTrackTableCellEnter(row, column) {
      if (column && column.label === '位置') {
        this.resolveTrackLocation(row);
      }
    },
    // 解析停靠点位置（鼠标悬停时调用）
    resolveParkingLocation(row) {
      if (!row) return;
      if (this.qualityMode && ['未知位置', '未解析'].includes(row.location)) row.location = '';
      if (row.location && row.location !== '鼠标移上获取位置...') return;

      const lon = row.lon;
      const lat = row.lat;
      if (!lon || !lat) return;

      const coordKey = `${lon.toFixed(6)},${lat.toFixed(6)}`;

      if (this.locationCache[coordKey]) {
        this.$set(row, 'location', this.locationCache[coordKey]);
        return;
      }

      this.getLocationByCoord(lon, lat, coordKey, (address) => {
        this.$set(row, 'location', this.qualityMode && !this.isValidResolvedAddress(address) ? '未解析' : address);
      });
    },
    // 解析轨迹点位置（鼠标悬停时调用）
    resolveTrackLocation(row) {
      if (!row) return;
      if (this.qualityMode && ['未知位置', '未解析'].includes(row.location)) row.location = '';
      if (row.location && row.location !== '鼠标移上获取位置...') return;

      const lon = row.lon;
      const lat = row.lat;
      if (!lon || !lat) return;

      const coordKey = `${lon.toFixed(6)},${lat.toFixed(6)}`;

      if (this.locationCache[coordKey]) {
        this.$set(row, 'location', this.locationCache[coordKey]);
        return;
      }

      this.getLocationByCoord(lon, lat, coordKey, (address) => {
        this.$set(row, 'location', this.qualityMode && !this.isValidResolvedAddress(address) ? '未解析' : address);
      });
    },
    // 根据经纬度获取位置信息（天地图逆地理）
    getLocationByCoord(lon, lat, coordKey, callback) {
      // 统一地址解析入口：缓存 -> 高德 -> stopaddress 兜底
      this.resolveAddressByCoord(lon, lat, coordKey)
        .then((address) => {
          if (callback && typeof callback === 'function') {
            callback(address);
          }
          this.$forceUpdate();
        })
        .catch((e) => {
          console.warn('逆地理编码不可用', e);
        });
    },
    normalizeCoordKey(lon, lat) {
      const lonNum = Number(lon);
      const latNum = Number(lat);
      if (!Number.isFinite(lonNum) || !Number.isFinite(latNum)) return '';
      // 固定 6 位避免浮点尾差导致同坐标重复解析
      return `${lonNum.toFixed(6)},${latNum.toFixed(6)}`;
    },
    cacheResolvedAddress(coordKey, address) {
      if (!coordKey || !this.isValidResolvedAddress(address)) return;
      const globalCache = getGlobalCoordAddressCache();
      globalCache.set(coordKey, address);
      this.$set(this.locationCache, coordKey, address);
    },
    getCachedAddress(coordKey) {
      if (!coordKey) return '';
      if (this.locationCache[coordKey] && this.isValidResolvedAddress(this.locationCache[coordKey])) {
        return this.locationCache[coordKey];
      }
      const globalCache = getGlobalCoordAddressCache();
      const cachedAddress = globalCache.get(coordKey);
      if (this.isValidResolvedAddress(cachedAddress)) {
        this.$set(this.locationCache, coordKey, cachedAddress);
        return cachedAddress;
      }
      return '';
    },
    isValidResolvedAddress(address) {
      if (address == null) return false;
      const text = String(address).trim();
      return !!text && text !== '未知位置' && text !== '暂无数据' && text !== '鼠标移上获取位置...';
    },
    reverseGeocodeByAmap(lon, lat) {
      const lonNum = Number(lon);
      const latNum = Number(lat);
      if (!Number.isFinite(lonNum) || !Number.isFinite(latNum)) {
        return Promise.resolve('');
      }
      if (!window.AMap) return Promise.resolve('');
      return new Promise((resolve) => {
        const runGetAddress = (geocoder) => {
          if (!geocoder || typeof geocoder.getAddress !== 'function') {
            resolve('');
            return;
          }
          geocoder.getAddress([lonNum, latNum], (status, result) => {
            if (status !== 'complete' || !result || !result.regeocode) {
              resolve('');
              return;
            }
            const address = String(result.regeocode.formattedAddress || '').trim();
            resolve(address);
          });
        };
        try {
          if (window.AMap.Geocoder) {
            runGetAddress(new window.AMap.Geocoder({}));
            return;
          }
          if (typeof window.AMap.plugin === 'function') {
            window.AMap.plugin('AMap.Geocoder', () => {
              runGetAddress(new window.AMap.Geocoder({}));
            });
            return;
          }
        } catch (e) {
          console.warn('高德逆地理解析异常', e);
        }
        resolve('');
      });
    },
    async resolveAddressByCoord(lon, lat, coordKey) {
      const normalizedKey = coordKey || this.normalizeCoordKey(lon, lat);
      const cached = this.getCachedAddress(normalizedKey);
      if (cached) return cached;

      // 1) 优先高德逆地理
      const amapAddress = await this.reverseGeocodeByAmap(lon, lat);
      if (this.isValidResolvedAddress(amapAddress)) {
        this.cacheResolvedAddress(normalizedKey, amapAddress);
        return amapAddress;
      }

      return '未知位置';
    },
    // 关闭行程信息
    closeTripInfo() {
      this.showTripInfo = false;
    },
    // 复制行程信息
    copyTripInfo() {
      if (!this.tripStartInfo || !this.tripEndInfo) return;

      const idVal = this.plateForTripHeader || ''
      const tripInfo = `车牌号：${idVal}
总里程：${this.displayTripSummary.distance}    总耗时：${this.displayTripSummary.duration}
开始：${this.tripStartInfo.time}
经度：${Number(this.qualityMode ? this.tripStartInfo.wgsLongitude : this.tripStartInfo.lon).toFixed(6)}    纬度：${Number(this.qualityMode ? this.tripStartInfo.wgsLatitude : this.tripStartInfo.lat).toFixed(6)}
${this.tripStartLocationDisplay}
结束：${this.tripEndInfo.time}
经度：${Number(this.qualityMode ? this.tripEndInfo.wgsLongitude : this.tripEndInfo.lon).toFixed(6)}    纬度：${Number(this.qualityMode ? this.tripEndInfo.wgsLatitude : this.tripEndInfo.lat).toFixed(6)}
${this.tripEndLocationDisplay}`;

      // 创建临时文本区域
      const textarea = document.createElement('textarea');
      textarea.value = tripInfo;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        // 执行复制命令
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (err) {
        this.$message.error('复制失败');
      } finally {
        // 清理临时元素
        document.body.removeChild(textarea);
      }
    },
    // 暂停轨迹
    pauseTrack() {
      if (this.pathNavigatorActive) {
        if (this.sliderDragging) {
          this.emitPathNavSeekFromCurrentElapsed();
        }
        this.sliderDragging = false;
        // 先置 isPlaying=false，父组件 pathNavPause 里 syncFromPathNavigatorRatio 发出的进度里才是暂停态
        this.stopPlaybackTimer();
        this.$emit('path-nav-control', { type: 'pause' });
        // 灰/绿线由父组件 pathNavPause → syncFromPathNavigatorRatio(真实车标经纬度) 更新，勿再用时间插值 applyPlaybackPosition 覆盖
        return;
      }
      this.stopPlaybackTimer();
      // 同步一次进度与 isPlaying，便于地图信息窗恢复「位置」等展示
      this.applyPlaybackPosition();
    },
    // 创建车辆标记（位置与朝向与当前 playElapsedSeconds 一致）
    createVehicleMarker() {
      if (this.pathNavigatorActive) return;
      if (!window.AMap || this.vehicleMarker) return;

      const trackData = this.processedTrackData;
      if (!trackData || trackData.length === 0) return;

      const pos = this.interpolatePositionAtElapsed(this.playElapsedSeconds);
      const rotation = pos && pos.bearing != null ? pos.bearing : 0;
      const lon = pos ? pos.lon : trackData[0].lon;
      const lat = pos ? pos.lat : trackData[0].lat;

      this.vehicleMarker = new window.AMap.Marker({
        position: [lon, lat],
        icon: new window.AMap.Icon({
          size: new window.AMap.Size(40, 40),
          image: require('@/assets/icon-08.28381b4.png'),
          imageSize: new window.AMap.Size(40, 40)
        }),
        offset: new window.AMap.Pixel(-20, -20),
        angle: rotation
      });

      this.$emit('add-marker', this.vehicleMarker);
    },
    // 计算两点之间的方位角（角度）
    calculateBearing(point1, point2) {
      const lat1 = point1.lat * Math.PI / 180;
      const lon1 = point1.lon * Math.PI / 180;
      const lat2 = point2.lat * Math.PI / 180;
      const lon2 = point2.lon * Math.PI / 180;

      const y = Math.sin(lon2 - lon1) * Math.cos(lat2);
      const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
      let bearing = Math.atan2(y, x) * 180 / Math.PI;

      // 转换为0-360度
      if (bearing < 0) {
        bearing += 360;
      }

      // 调整角度，减少90度，确保箭头正确对准行驶方向
      bearing -= 90;
      if (bearing < 0) {
        bearing += 360;
      }

      return bearing;
    },
    // 格式化时间（秒数转时分秒）
    formatTime(seconds) {
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    },
    forceExpandedCaptureLayout() {
      this.$emit('prepare-capture-layout', {
        isCollapsed: false,
        isExpandedNum: 3,
        restore: false
      })
    },
    openExportDialog() {
      if (this.qualityMode && this.independentExportHandler) return this.independentExportHandler()
      if (this.exporting) return false
      if (!this.rangeFilteredTrackData.length) {
        this.$message.warning('当前范围暂无轨迹可导出')
        return false
      }
      this.forceExpandedCaptureLayout()
      this.exportOptionFull = this.qualityMode;
      this.exportOptionParkingOnly = !this.qualityMode;
      this.exportDialogVisible = true;
      return true;
    },
    async onTrajectoryShareClick() {
      if (!this.trajectoryShareEnabled || typeof this.trajectoryShareHandler !== 'function') return
      this.resetTrajectoryShareDialog()
      this.trajectoryShareDialogVisible = true
    },
    async createTrajectoryShare() {
      this.trajectoryShareUrl = ''
      this.trajectoryShareSubmitting = true
      try {
        const result = await this.trajectoryShareHandler({
          scope: this.trajectoryShareScope,
          expiresInHours: this.trajectoryShareExpiresInHours
        })
        const value = result && typeof result === 'object' ? result : { url: result }
        this.trajectoryShareUrl = value.url ? String(value.url) : ''
        this.trajectoryShareId = value.shareId ? String(value.shareId) : ''
        this.trajectoryShareScope = value.scope || this.trajectoryShareScope
        this.trajectoryShareExpiresAt = value.expiresAt || ''
        if (!this.trajectoryShareUrl) {
          this.$message.warning('分享链接不可用，请稍后重试')
          return
        }
      } catch (e) {
        this.$message.warning((e && (e.msg || e.message)) || '分享链接不可用，请稍后重试')
      } finally {
        this.trajectoryShareSubmitting = false
      }
    },
    async revokeTrajectoryShare() {
      if (!this.trajectoryShareId || typeof this.trajectoryShareRevokeHandler !== 'function') return
      this.trajectoryShareRevoking = true
      try {
        await this.trajectoryShareRevokeHandler(this.trajectoryShareId)
        this.$message.success('分享已撤销')
        this.trajectoryShareDialogVisible = false
      } catch (e) {
        this.$message.warning((e && (e.msg || e.message)) || '撤销分享失败，请稍后重试')
      } finally {
        this.trajectoryShareRevoking = false
      }
    },
    resetTrajectoryShareDialog() {
      this.trajectoryShareUrl = ''
      this.trajectoryShareId = ''
      this.trajectoryShareScope = 'FULL_TRIP'
      this.trajectoryShareExpiresInHours = 72
      this.trajectoryShareExpiresAt = ''
      this.trajectoryShareSubmitting = false
      this.trajectoryShareRevoking = false
    },
    async copyTrajectoryShareUrl() {
      if (!this.trajectoryShareUrl) return
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.trajectoryShareUrl)
        } else {
          this.fallbackCopyTrajectoryShareUrl(this.trajectoryShareUrl)
          return
        }
        this.$message.success('已复制到剪贴板')
      } catch (e) {
        this.fallbackCopyTrajectoryShareUrl(this.trajectoryShareUrl)
      }
    },
    fallbackCopyTrajectoryShareUrl(text) {
      try {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.left = '-9999px'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message.success('已复制到剪贴板')
      } catch (e) {
        this.$message.error('复制失败')
      }
    },
    onExportOptionParkingOnlyChange() {
      if (this.exportOptionParkingOnly) {
        this.exportOptionFull = false;
      } else if (!this.exportOptionFull) {
        this.exportOptionFull = true;
      }
    },
    onExportOptionFullChange() {
      if (this.exportOptionFull) {
        this.exportOptionParkingOnly = false;
      } else if (!this.exportOptionParkingOnly) {
        this.exportOptionParkingOnly = true;
      }
    },
    confirmExportFromDialog() {
      if (this.exporting) return
      if (!this.exportOptionParkingOnly && !this.exportOptionFull) {
        this.$message.warning('请选择一种导出方式');
        return;
      }
      this.forceExpandedCaptureLayout()
      const parkingOnly = this.exportOptionParkingOnly;
      this.exportDialogVisible = false;
      return this.runExportData(parkingOnly);
    },
    cancelExportRegeo() {
      this.exportCancelRequested = true
      this.exportRegeoProgressVisible = false
      this.exportRegeoProgressLabel = '已取消导出'
      this.$message.info('已取消导出')
    },
    async prepareCaptureLayout() {
      this.forceExpandedCaptureLayout()
      await this.$nextTick()
      await new Promise((resolve) => setTimeout(resolve, 120))
    },
    // 导出数据（调整顺序）；parkingOnly 为 true 时仅对停靠点做逆地理，轨迹明细仍导出但不对轨迹点解析地址
    async runExportData(parkingOnly) {
      if (this.exporting) return
      if (!this.rangeFilteredTrackData.length) return this.$message.warning('当前范围暂无轨迹可导出')
      // 地址解析期间筛选区间可能变化，三张表始终使用发起导出时的数据。
      const trackData = this.rangeFilteredTrackData.map(item => ({ ...item }))
      const parkingData = this.rangeFilteredParkingData.map(item => ({ ...item }))
      const includeWaybill = trackData.some(item => item.waybillNo) || parkingData.some(item => item.waybillNo)
      this.exporting = true
      try {
        this.exportCancelRequested = false
        this.$message({ type: 'info', message: '正在准备导出数据，请稍候...' });

        // 1. 先捕获地图截图（确保地图已加载）
        await this.prepareCaptureLayout();
        const mapImageBase64 = await this.captureMapFromContainer({ trackData });

        // 2. 再处理坐标和位置数据
        const parkingCoords = [];
        const parkingUniqueCoords = new Set();
        parkingData.forEach(item => {
          if (item.lon && item.lat) {
            const coord = `${item.lon},${item.lat}`;
            if (!parkingUniqueCoords.has(coord)) {
              parkingUniqueCoords.add(coord);
              parkingCoords.push(coord);
            }
          }
        });

        const trackCoords = [];
        const trackUniqueCoords = new Set();
        if (!parkingOnly) {
          trackData.forEach(item => {
            if (item.lon && item.lat) {
              const coord = `${item.lon},${item.lat}`;
              if (!trackUniqueCoords.has(coord)) {
                trackUniqueCoords.add(coord);
                trackCoords.push(coord);
              }
            }
          });
        }

        const totalSteps = parkingCoords.length + (parkingOnly ? 0 : trackCoords.length);
        let done = 0;
        let lastProgressAt = 0;
        const afterEach = async () => {
          if (this.exportCancelRequested) {
            throw new Error('__EXPORT_CANCELLED__')
          }
          done += 1;
          const now = Date.now();
          const force = done === 1 || done >= totalSteps;
          if (!force && now - lastProgressAt < 100) return;
          lastProgressAt = now;
          this.exportRegeoProgress = totalSteps ? Math.round((done / totalSteps) * 100) : 100;
          this.exportRegeoProgressLabel = `正在解析地址 ${done}/${totalSteps}`;
        };

        if (totalSteps > 0) {
          this.exportRegeoProgress = 0;
          this.exportRegeoProgressLabel = `正在解析地址 0/${totalSteps}`;
          this.exportRegeoProgressVisible = true;
          await this.$nextTick();
        }

        let parkingLocationData = {};
        if (parkingCoords.length > 0) {
          parkingLocationData = await this.batchProcessCoords(parkingCoords, afterEach);
        }

        let trackLocationData = {};
        if (!parkingOnly && trackCoords.length > 0) {
          trackLocationData = await this.batchProcessCoords(trackCoords, afterEach);
        }

        if (this.exportCancelRequested) {
          throw new Error('__EXPORT_CANCELLED__')
        }

        // 3. 最后生成Excel；轨迹工作表始终导出；parkingOnly 时轨迹「位置」列固定为「未解析」、不做逆地理
        await this.downloadExportFile(parkingLocationData, trackLocationData, mapImageBase64, {
          includeTrackSheet: true,
          parkingOnlyRegeo: parkingOnly,
          trackData,
          parkingData,
          includeWaybill
        });

        this.$message({ type: 'success', message: '导出成功！' });
      } catch (error) {
        if (error && error.message === '__EXPORT_CANCELLED__') {
          // 用户主动取消，不提示失败
        } else {
          this.$message.error('导出失败，请重试');
        }
      } finally {
        this.exportRegeoProgressVisible = false;
        this.exporting = false;
      }
    },
    // 多并发天地图逆地理（保序）：数量越大并发越高，并优先命中全局坐标缓存
    async batchProcessCoords(coords, onEachResolved) {
      return tiandituDecodeCoordsConcurrent(coords, {
        shouldCancel: () => this.exportCancelRequested,
        fallbackResolve: (lon, lat) => this.resolveAddressByCoord(
          lon,
          lat,
          this.normalizeCoordKey(lon, lat)
        ),
        onProgress: async () => {
          if (typeof onEachResolved === 'function') {
            await onEachResolved()
          }
        }
      })
    },
    // 兼容旧调用：按 # 分隔的坐标串逐条天地图逆地理
    async getAddressList(coordsStr) {
      const coords = String(coordsStr || '')
        .split('#')
        .map((s) => s.trim())
        .filter(Boolean);
      try {
        const { resultList } = await tiandituDecodeCoordsSequential(coords);
        const successCount = resultList.filter((r) => r.success).length;
        return {
          success: true,
          code: 0,
          msg: '',
          data: {
            resultList,
            successCount,
            failCount: resultList.length - successCount
          }
        };
      } catch (error) {
        return {
          success: false,
          code: -1,
          msg: String(error && error.message ? error.message : error),
          data: {
            resultList: [],
            successCount: 0,
            failCount: coords.length
          }
        };
      }
    },

    // 捕获地图截图
    captureMap() {
      return new Promise((resolve) => {
        setTimeout(() => {
          // 模拟地图截图URL
          const mockMapImage = 'https://via.placeholder.com/800x600?text=Map+Screenshot';
          resolve(mockMapImage);
        }, 500);
      });
    },
    // 下载导出文件
    // 下载导出文件（接收mapImageBase64参数）
    /**
     * @param exportOptions.includeTrackSheet 是否包含轨迹明细表（默认 true）
     * @param exportOptions.parkingOnlyRegeo 仅解析停靠点时 true：轨迹「位置」列写「未解析」
     */
    async downloadExportFile(
      parkingLocationData,
      trackLocationData,
      mapImageBase64,
      exportOptions = {}
    ) {
      const includeTrackSheet = exportOptions.includeTrackSheet !== false;
      const parkingOnlyRegeo = exportOptions.parkingOnlyRegeo === true;
      const trackData = exportOptions.trackData || this.rangeFilteredTrackData;
      const parkingData = exportOptions.parkingData || this.rangeFilteredParkingData;
      const includeWaybill = exportOptions.includeWaybill === undefined ? this.runRoute.some(item => item.waybillNo) : exportOptions.includeWaybill;
      // 文件生成和下载异常由导出流程统一提示，不能在此吞掉。
        // ✅ 关键修复：创建 Excel 工作簿实例
        const workbook = new ExcelJS.Workbook();
        workbook.creator = '铁路管理系统';
        workbook.lastModifiedBy = '铁路管理系统';
        workbook.created = new Date();
        workbook.modified = new Date();

        // ========== 1. 停靠点明细工作表 ==========
        const parkingSheet = workbook.addWorksheet('停靠点明细');
        parkingSheet.columns = [
          { header: '序号', key: 'index', width: 8 },
          ...(includeWaybill ? [{ header: '运单号', key: 'waybillNo', width: 24 }] : []),
          { header: '停车时长', key: 'duration', width: 16 },
          { header: '停车开始时间', key: 'startTime', width: 22 },
          { header: '停车结束时间', key: 'endTime', width: 22 },
          { header: '停车位置', key: 'location', width: 45 }
        ];
        parkingSheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFF' } };
        parkingSheet.getRow(1).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '4472C4' }
        };
        parkingSheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' };
        parkingSheet.getRow(1).height = 25;

        parkingData.forEach((item, index) => {
          let location = item.location || '未知位置';
          if (parkingLocationData && parkingLocationData.resultList) {
            const result = parkingLocationData.resultList.find(r =>
              r.lon === item.lon &&
              r.lat === item.lat
            );
            if (result && result.success) {
              location = `${result.des}`;
            }
          }
          const row = parkingSheet.addRow({
            waybillNo: item.waybillNo,
            index: index + 1,
            duration: item.duration,
            startTime: item.startTime,
            endTime: item.endTime,
            location: location
          });
          row.height = 30;
          row.getCell('index').alignment = { horizontal: 'left', vertical: 'middle' };
        });

        // ========== 2. 轨迹明细工作表（可选）==========
        if (includeTrackSheet) {
          const trackSheet = workbook.addWorksheet('轨迹明细');
          trackSheet.columns = [
            ...(includeWaybill ? [{ header: '运单号', key: 'waybillNo', width: 24 }] : []),
            { header: '时间', key: 'time', width: 22 },
            { header: '位置', key: 'location', width: 80 },
            { header: '坐标', key: 'coordinate', width: 35 },
            { header: '方向', key: 'agl', width: 10 },
            { header: '上报里程', key: 'mil', width: 14 },
            { header: '海拔', key: 'hgt', width: 12 },
            { header: '速度', key: 'speed', width: 12 }
          ];
          trackSheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFF' } };
          trackSheet.getRow(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '4472C4' }
          };
          trackSheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' };
          trackSheet.getRow(1).height = 25;

          trackData.forEach(item => {
            let location;
            if (parkingOnlyRegeo) {
              location = '未解析';
            } else {
              location = item.location || '未知位置';
              if (trackLocationData && trackLocationData.resultList) {
                const result = trackLocationData.resultList.find(r =>
                  r.lon === item.lon &&
                  r.lat === item.lat
                );
                if (result && result.success) {
                  location = `${result.des}`;
                }
              }
            }
            const row = trackSheet.addRow({
              waybillNo: item.waybillNo,
              time: item.time,
              location: location,
              coordinate: item.coordinate,
              agl: directionToCardinal8(item.agl),
              mil: item.mil || 0,
              hgt: item.hgt != null ? item.hgt : 0,
              speed: item.speed
            });
            row.height = 30;
            row.getCell('coordinate').alignment = { horizontal: 'right', vertical: 'middle' };
            row.getCell('speed').alignment = { horizontal: 'right', vertical: 'middle' };
          });
        }

        // ========== 3. 轨迹地图工作表 ==========
        const mapSheet = workbook.addWorksheet('轨迹地图');
        mapSheet.addRow(['轨迹地图']);
        mapSheet.getRow(1).font = { bold: true, size: 16 };
        mapSheet.getRow(1).alignment = { horizontal: 'center' };
        mapSheet.mergeCells('A1:F1');
        mapSheet.columns.forEach(column => { column.width = 30; });

        // 导出地图尺寸：与 buildAmapStaticMapUrl 的高清尺寸一致，减少 Excel 中查看时的模糊感
        const exportMapExtW = 960;
        const exportMapExtH = 540;
        /** 为悬浮图预留行数，避免「注」与图片重叠（按默认行高约 15pt 估算） */
        const exportMapNoteRowSkip = Math.max(36, Math.ceil(exportMapExtH / 18) + 2);

        if (mapImageBase64) {
          try {
            const mapImageId = workbook.addImage({
              name: 'map_screenshot', // 必须保留name字段
              base64: mapImageBase64,
              extension: 'png'
            });
            mapSheet.addImage(mapImageId, {
              tl: { col: 0, row: 1 },
              ext: { width: exportMapExtW, height: exportMapExtH },
              editAs: 'oneCell'
            });
            for (let i = 0; i < exportMapNoteRowSkip; i++) {
              mapSheet.addRow([]);
            }
            const noteRow = mapSheet.addRow(['注: 地图截图已插入上方']);
            noteRow.alignment = { horizontal: 'center' };
            mapSheet.mergeCells(`A${noteRow.number}:F${noteRow.number}`);
          } catch (error) {
            mapSheet.addRow(['地图截图插入失败']);
            mapSheet.getRow(2).alignment = { horizontal: 'center' };
            mapSheet.mergeCells('A2:F2');
          }
        } else {
          mapSheet.addRow(['未获取到地图截图，请确保地图已完全加载']);
          mapSheet.getRow(2).alignment = { horizontal: 'center' };
          mapSheet.mergeCells('A2:F2');
        }

        // ========== 4. 生成并下载文件 ==========
        const buffer = await workbook.xlsx.writeBuffer();
        if (this.exportCancelRequested) throw new Error('__EXPORT_CANCELLED__');
        saveAs(
          new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          `轨迹数据导出_${new Date().toISOString().slice(0, 19).replace(/[-:]/g, '')}.xlsx`
        );
    },
    /** WebService 静态图：不传 location/zoom，由服务端按 paths 包住整段轨迹 */
    buildAmapStaticMapUrl(trackData = this.rangeFilteredTrackData) {
      if (trackData.some(point => point.segmentKey !== undefined)) {
        const groups = []
        trackData.forEach((point, index, points) => {
          if (!index || point.segmentKey !== points[index - 1].segmentKey) groups.push([])
          groups[groups.length - 1].push(point)
        })
        const urls = groups.map(points => buildAmapStaticMapUrlFromTrackPoints(points, { maxPts: 400, size: '1024*1024', scale: 2, stroke: '8,0xFF0000,1,,' })).filter(Boolean)
        if (!urls.length) return null
        const url = new URL(urls[0])
        url.searchParams.set('paths', urls.map(value => new URL(value).searchParams.get('paths')).join('|'))
        return url.toString()
      }
      return buildAmapStaticMapUrlFromTrackPoints(trackData, {
        maxPts: 400,
        size: '1024*1024',
        scale: 2,
        stroke: '8,0xFF0000,1,,'
      });
    },
    /** fetch 拉取静态图再绘到 canvas，避免 img 跨域导致 canvas 空白 */
    async loadImageUrlAsPngBase64(url) {
      if (!url) return null;
      try {
        const res = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!res.ok) return null;
        const blob = await res.blob();
        if (typeof createImageBitmap === 'function') {
          const bitmap = await createImageBitmap(blob);
          try {
            const canvas = document.createElement('canvas');
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#e8ecf0';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(bitmap, 0, 0);
            return canvas.toDataURL('image/png').split(',')[1];
          } finally {
            if (bitmap.close) bitmap.close();
          }
        }
        return await this.loadImageBlobViaImg(blob);
      } catch (e) {
        return null;
      }
    },
    loadImageBlobViaImg(blob) {
      return new Promise((resolve) => {
        const u = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#e8ecf0';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(u);
            resolve(canvas.toDataURL('image/png').split(',')[1]);
          } catch (err) {
            URL.revokeObjectURL(u);
            resolve(null);
          }
        };
        img.onerror = () => {
          URL.revokeObjectURL(u);
          resolve(null);
        };
        img.src = u;
      });
    },
    getMapContainerElement() {
      return (
        document.getElementById('amap') ||
        document.querySelector('.transport-service-track-map .mapContainer') ||
        document.querySelector('.mapContainer')
      );
    },
    async waitForMapRenderStable(map) {
      const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      if (!map || typeof map.once !== 'function') {
        await wait(500);
        return;
      }
      await new Promise((resolve) => {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          resolve();
        };
        try {
          map.once('complete', finish);
        } catch (e) {
          finish();
          return;
        }
        setTimeout(finish, 1200);
      });
      await wait(250);
    },
    /**
     * 将行程信息面板叠到地图 PNG 上，并裁剪为视口矩形：
     * 从 trip-info 左下角 (left, bottom) 到可视区域右上角 (innerWidth, 0) 所围成的区域。
     */
    async compositeTripInfoOntoMapBase64(mapBase64NoPrefix) {
      if (!mapBase64NoPrefix) return null;
      const tripEl = this.$refs.tripInfoPanel;
      const mapEl = this.getMapContainerElement();
      if (!tripEl || !mapEl) return mapBase64NoPrefix;
      const style = window.getComputedStyle(tripEl);
      if (style.display === 'none' || style.visibility === 'hidden' || tripEl.offsetWidth < 2) {
        return mapBase64NoPrefix;
      }
      return new Promise((resolve) => {
        const mapImg = new Image();
        mapImg.onload = async () => {
          try {
            const w = mapImg.naturalWidth || mapImg.width;
            const h = mapImg.naturalHeight || mapImg.height;
            const mapRect = mapEl.getBoundingClientRect();
            const tripRect = tripEl.getBoundingClientRect();
            if (mapRect.width < 1 || mapRect.height < 1) {
              resolve(mapBase64NoPrefix);
              return;
            }
            const vw = window.innerWidth;
            if (tripRect.bottom <= 0 || tripRect.left >= vw) {
              resolve(mapBase64NoPrefix);
              return;
            }
            const sx = w / mapRect.width;
            const sy = h / mapRect.height;
            /** 视口裁剪：左 = trip-info 左缘，上 = 地图顶边（避开 Layout 顶栏等非地图区域），右 = 视口宽，下 = trip-info 底边 */
            const R = { left: tripRect.left, top: mapRect.top, right: vw, bottom: tripRect.bottom };
            const cropW = Math.max(1, Math.round(R.right - R.left));
            const cropH = Math.max(1, Math.round(R.bottom - R.top));
            // 以地图截图的实际像素密度输出，避免合成后再次按 CSS 像素降采样导致发糊
            const outW = Math.max(1, Math.round(cropW * sx));
            const outH = Math.max(1, Math.round(cropH * sy));
            const canvas = document.createElement('canvas');
            canvas.width = outW;
            canvas.height = outH;
            const ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.fillStyle = '#e8ecf0';
            ctx.fillRect(0, 0, outW, outH);
            const ix1 = Math.max(R.left, mapRect.left);
            const ix2 = Math.min(R.right, mapRect.right);
            const iy1 = Math.max(R.top, mapRect.top);
            const iy2 = Math.min(R.bottom, mapRect.bottom);
            if (ix1 < ix2 && iy1 < iy2) {
              const srcX = (ix1 - mapRect.left) * sx;
              const srcY = (iy1 - mapRect.top) * sy;
              const srcW = (ix2 - ix1) * sx;
              const srcH = (iy2 - iy1) * sy;
              const dstX = (ix1 - R.left) * sx;
              const dstY = (iy1 - R.top) * sy;
              const dstW = (ix2 - ix1) * sx;
              const dstH = (iy2 - iy1) * sy;
              ctx.drawImage(mapImg, srcX, srcY, srcW, srcH, dstX, dstY, dstW, dstH);
            }
            const tripCanvas = await html2canvas(tripEl, {
              useCORS: true,
              allowTaint: true,
              scale: Math.min(window.devicePixelRatio || 1, 3),
              backgroundColor: null,
              logging: false,
              width: tripEl.offsetWidth,
              height: tripEl.offsetHeight
            });
            const tx = (tripRect.left - R.left) * sx;
            const ty = (tripRect.top - R.top) * sy;
            const tw = tripRect.width * sx;
            const th = tripRect.height * sy;
            ctx.drawImage(
              tripCanvas,
              0,
              0,
              tripCanvas.width,
              tripCanvas.height,
              tx,
              ty,
              tw,
              th
            );
            resolve(canvas.toDataURL('image/png').split(',')[1]);
          } catch (e) {
            resolve(mapBase64NoPrefix);
          }
        };
        mapImg.onerror = () => resolve(mapBase64NoPrefix);
        mapImg.src = `data:image/png;base64,${mapBase64NoPrefix}`;
      });
    },
    /**
     * 与「数据导出」中轨迹地图一致：高德静态图 / DOM 截图得到轨迹，再叠加 trip-info（起终点地址等）
     */
    async downloadTripViewportScreenshot() {
      this.forceExpandedCaptureLayout()
      const loading = this.$loading({
        lock: true,
        text: '正在生成地图与行程截图…',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.35)'
      })

      try {
        await this.prepareCaptureLayout()
        const mapB64 = await this.captureMapFromContainer()
        if (!mapB64) {
          this.$message.error('未获取到地图截图，请确保地图与轨迹已加载')
          return
        }
        const blob = await (await fetch(`data:image/png;base64,${mapB64}`)).blob()
        const name = `轨迹地图截图_${new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '')}.png`
        saveAs(blob, name)
        this.$message.success('截图已下载')
      } catch (e) {
        this.$message.error('截图失败，请稍后重试')
      } finally {
        loading.close()
      }
    },
    async captureMapDomFallback() {
      const map = window.__AMAP_MAP__ || window.map;
      if (map) {
        try {
          await this.waitForMapRenderStable(map);
          const shot = new Screenshot(map);
          const dataUrl = await shot.toDataURL('image/png');
          if (dataUrl && dataUrl.length > 2000) {
            return dataUrl.split(',')[1];
          }
        } catch (e) {
          console.warn('@amap/screenshot 失败', e);
        }
      }
      const el = this.getMapContainerElement();
      if (!el) return null;
      await new Promise((r) => setTimeout(r, 400));
      try {
        const canvas = await html2canvas(el, {
          useCORS: true,
          allowTaint: true,
          scale: Math.min(window.devicePixelRatio || 1, 3),
          backgroundColor: '#e8ecf0',
          logging: false,
          width: el.clientWidth,
          height: el.clientHeight
        });
        const b64 = canvas.toDataURL('image/png').split(',')[1];
        return b64 && b64.length > 2000 ? b64 : null;
      } catch (e) {
        return null;
      }
    },
    async captureMapFromContainer(options = {}) {
      const includeTripInfo = options.includeTripInfo !== false;
      let mapB64 = null;
      try {
        const trackData = options.trackData || this.rangeFilteredTrackData;
        if (trackData && trackData.length >= 2) {
          const staticUrl = this.buildAmapStaticMapUrl(trackData);
          if (staticUrl) {
            mapB64 = await this.loadImageUrlAsPngBase64(staticUrl);
          }
        }
      } catch (e) {
        console.warn('高德静态图失败', e);
      }
      const staticOk = mapB64 && mapB64.length > 3000;
      if (!staticOk) {
        const domB64 = await this.captureMapDomFallback();
        if (domB64 && (!mapB64 || domB64.length > (mapB64.length || 0))) {
          mapB64 = domB64;
        }
      }
      if (!mapB64) return null;
      if (!includeTripInfo) return mapB64;
      return this.compositeTripInfoOntoMapBase64(mapB64);
    },
    // 定位到地图并展示弹窗
    onSpeedCurvePointClick(payload) {
      handleSpeedCurvePointClick(this, payload)
    },
    goToMap(locationData) {
      let speedRaw =
        locationData && locationData.spdNum != null && locationData.spdNum !== ''
          ? locationData.spdNum
          : locationData && locationData.speed != null
            ? locationData.speed
            : 0
      if (this.qualityMode) speedRaw = locationData.spdNum != null && Number.isFinite(Number(locationData.spdNum)) && Number(locationData.spdNum) >= 0 ? Number(locationData.spdNum) : null
      // 向父组件发送事件，请求定位到地图并展示弹窗
      this.$emit('locate-on-map', {
        lon: locationData.lon,
        lat: locationData.lat,
        coordType: 'gcj02',
        location: locationData.location,
        time: locationData.time,
        gpsTime: this.qualityMode ? locationData.timeMs : undefined,
        speed: speedRaw,
        hgt: locationData.hgt != null && locationData.hgt !== '' ? locationData.hgt : (locationData.alt != null ? locationData.alt : null),
        agl: locationData.agl,
        angle: locationData.angle,
        gpsStatus: locationData.gpsStatus,
        pointIndex: locationData.pointIndex,
        plateNumber: this.mapLocatePrimaryId
      });
    },
    formatDate(dateString) {
    // 解析原始日期字符串
    const date = new Date(dateString);

    // 格式化日期
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
},
removeUnit1(speed) {
    return speed.split('km/h')[0];
},
    // 定位到地图并展示弹窗
    goToMapParking(locationData) {
      const parsedTime = this.formatDate(locationData.endTime)
      const newData = this.processedTrackData.find(item => item.time === parsedTime)
      if (this.qualityMode && !newData) return
      // 向父组件发送事件，请求定位到地图并展示弹窗
      this.$emit('locate-on-map', {
        lon: locationData.lon,
        lat:  locationData.lat,
        coordType: 'gcj02',
        location: locationData.location,
        time: newData.time,
        gpsTime: this.qualityMode ? newData.timeMs : undefined,
        speed: this.removeUnit1(newData.speed),
        hgt: newData.hgt?newData.hgt:0,
        agl: newData.agl,
        angle: locationData.angle,
        gpsStatus: locationData.gpsStatus,
        pointIndex: locationData.pointIndex,
        popupType: 'parking',
        parkingStartTime:this.formatDate(locationData.startTime),
        parkingEndTime: this.formatDate(locationData.endTime),
        parkingDuration: locationData.duration || locationData.parkingDuration,
        plateNumber: this.mapLocatePrimaryId
      });
    }
  },
}
</script>
<style>
.trip-player-slider-tooltip {
  z-index: 20050 !important;
}

.el-button {
  font-size: 0.875rem !important;
  padding: 0.5rem!important;
  box-sizing: border-box;
}

.el-tabs__item {
  font-size: 0.875rem !important;
}

.el-table thead th {
  font-size: 0.875rem !important;
  color: #333 !important;
}

.el-table tr td {
  font-size: 0.875rem !important;
}
.el-table .el-table__cell{
  padding: 0.4rem !important;
}
.el-pagination .el-input__inner{
  height: 1.8rem !important;
}
</style>
<style scoped>
@import '@/styles/playback-player.css';

.trip-info-popup {
  position: absolute;
  bottom: 0;
  left: 23rem;
  border-radius: 0.25rem;
  padding: 0.4rem 0.75rem;
  z-index: 9;
  width: calc(100% - 23rem);
  height: 100%;
}

.trip-info {
  width: 21rem;
  position: absolute;
  left: 23rem;
  z-index: 9;
  bottom: 28.3rem;
  margin: 0.4rem 0.75rem 0;
  padding: 0;
  overflow: hidden;
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 0.25rem 1.25rem rgba(15, 40, 80, 0.12), 0 0.0625rem 0.25rem rgba(15, 40, 80, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.trip-info__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.25rem 0.875rem;
  background: linear-gradient(135deg, #3a7afe 0%, #2b6ae8 100%);
  color: #fff;
}

.trip-info__plate {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
}
.trip-info__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.125rem;
}

.trip-info__icon-btn {
  padding: 0.25rem !important;
  min-width: auto !important;
  color: #fff !important;
  font-size: 1.125rem !important;
}

.trip-info__icon-btn:hover,
.trip-info__icon-btn:focus {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.18) !important;
}

.trip-info__icon-btn--close:hover {
  background: rgba(255, 255, 255, 0.22) !important;
}

.trip-info__summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  padding: 0.3rem 0.875rem;
  font-size: 0.8125rem;
  color: #303133;
  background: #fafbfc;
  border-bottom: 1px solid #eef0f3;
}

.trip-info__summary-item {
  flex: 1 1 auto;
  min-width: 0;
}

.trip-info__summary-item em {
  font-style: normal;
  font-weight: 600;
  color: #1a1a1a;
}

.trip-info__body {
  padding: 0.75rem 0.875rem 0.875rem;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.trip-section {
  margin: 0;
  padding: 0.625rem 0.75rem;
  background: #f0f7ff;
  border-radius: 0.5rem;
  border: 1px solid rgba(64, 158, 255, 0.12);
}

.trip-section__title {
  margin: 0 0 0.5rem;
  color: #303133;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.35;
}

.trip-section__coords {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem 1.25rem;
  margin-bottom: 0.375rem;
  font-size: 0.75rem;
  color: #606266;
}

.trip-section__addr {
  margin: 0;
  font-size: 0.75rem;
  color: #909399;
  line-height: 1.5;
  word-break: break-all;
}

.trip-edit-form .form-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.trip-edit-form .form-item {
  flex: 1;
  min-width: 0;
}

.trip-edit-map-wrap {
  width: 100%;
  height: 50vh;
  position: relative;
}

.trip-edit-map {
  width: 100%;
  height: 100%;
}

.trip-edit-map-search {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 9999;
  background-color: #fff;
  padding: 0.5rem;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
}

.video-player {
  background-color: #fffc;
  border-radius: 0.25rem;
  padding: 0.3rem 0.5rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  /* 2px = 0.125rem, 12px = 0.75rem */
  border: 1px solid #dcdfe6;
  margin-top: 0.2rem;
  width: 100%;
  overflow: visible;
}

.time-display {
  font-size: 0.875rem;
  color: #606266;
  min-width: 3.75rem;
  text-align: center;
}

.speed-picker {
  position: relative;
  flex-shrink: 0;
  width: 6.25rem;
  z-index: 3001;
}

.speed-picker__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 100%;
  height: 2rem;
  padding: 0 0.5rem;
  font-size: 0.8125rem;
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 0.25rem;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.speed-picker__trigger:hover {
  border-color: #c0c4cc;
}

.speed-picker__trigger.is-open {
  border-color: var(--layout-primary, #087dff);
  box-shadow: 0 0 0 1px var(--layout-primary-focus-shadow, rgba(8, 125, 255, 0.2));
}

.speed-picker__caret {
  font-size: 0.75rem;
  transition: transform 0.2s;
}

.speed-picker__trigger.is-open .speed-picker__caret {
  transform: rotate(180deg);
}

.speed-picker__dropdown {
  position: absolute;
  bottom: calc(100% + 0.5rem);
  left: 50%;
  transform: translateX(-50%);
  min-width: 5.5rem;
  padding: 0.375rem 0;
  background: #fff;
  border-radius: 0.375rem;
  box-shadow: 0 0.25rem 1rem rgba(15, 40, 80, 0.12), 0 0.125rem 0.375rem rgba(15, 40, 80, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.speed-picker__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.speed-picker__item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.5rem;
  padding: 0.375rem 1rem;
  font-size: 0.8125rem;
  color: #606266;
  cursor: pointer;
  user-select: none;
  transition: background 0.12s, color 0.12s;
}

.speed-picker__item:nth-child(even):not(.is-active) {
  background: rgba(250, 250, 250, 0.95);
}

.speed-picker__item:hover:not(.is-active) {
  background: #f5f7fa;
}

.speed-picker__item.is-active {
  background: #f0f7ff !important;
  color: var(--layout-primary, #087dff);
  font-weight: 600;
}

.speed-picker__arrow {
  position: absolute;
  bottom: -0.375rem;
  left: 50%;
  width: 0;
  height: 0;
  margin-left: -0.375rem;
  border-left: 0.375rem solid transparent;
  border-right: 0.375rem solid transparent;
  border-top: 0.375rem solid #fff;
  filter: drop-shadow(0 0.125rem 0.125rem rgba(15, 40, 80, 0.08));
  pointer-events: none;
}

.speed-picker-fade-enter-active,
.speed-picker-fade-leave-active {
  transition: opacity 0.15s ease;
}

.speed-picker-fade-enter,
.speed-picker-fade-leave-to {
  opacity: 0;
}

/* 占满一行，仅负责把内层推到右侧 */
.function-buttons-row {
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  margin-top: 0.2rem;
  position: absolute;
    bottom:320px;
    right: 0.75rem;
}

.function-buttons {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: max-content;
  max-width: 100%;
  box-sizing: border-box;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: #fffc;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  /* 2px = 0.125rem, 12px = 0.75rem */
  border: 1px solid #dcdfe6;
  font-size: 0.875rem;
}

.function-buttons__export {
  width: auto;
  flex: 0 0 auto;
}

.speed-chart {
  height: 12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  border-radius: 0.25rem;
}

/* 标签页样式 */
.el-tabs {
  background-color: #fffc;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  /* 2px = 0.125rem, 12px = 0.75rem */
  border: 1px solid #dcdfe6;
  overflow: hidden;
  padding: 0 0.625rem;
  margin-top: 0.2rem;

}

.el-tabs__header {
  margin: 0;
  padding: 0.5rem;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.el-tabs__content {
  padding: 0.5rem;
  height: calc(100% - 2.5rem);
  overflow: auto;
}

.el-table {
  font-size: 0.75rem;
  height: 8rem;
  overflow: auto;
}

.el-table th,
.el-table td {
  padding: 0.375rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

/* 确保表格内容不换行 */
.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right-data-el-table--quality ::v-deep .cell {
  white-space: nowrap;
}

/* 限制表格容器高度 */
.el-tabs__content {
  padding: 0.5rem;
  overflow: hidden;
}

/* 限制表格主体高度 */
.el-table__body-wrapper {
  max-height: 5.25rem;
  overflow-y: auto;
}

/* 右侧监控区域展开状态 */
.right-panel.expanded {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  padding: 1rem;
  z-index: 1000;
}

/* 右侧监控区域隐藏状态 */
.right-panel.hidden {
  display: none;
}

/* 展开/收缩按钮样式 */
.expand-controls {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
  z-index: 99;
}

.expand-controls-fiex {
  display: flex;
  align-items: center;
  gap: 0.25rem;

}

.expand-controls-top {
  position: fixed;
  left: calc((100% + 22rem)/2);
  top: 0.625rem;
  z-index: 9999;
}


.expand-btn {
      width: 5rem;
    height: 1.2rem;
    padding: 0;
    background-color: var(--layout-primary, #087dff);
    border: none;
    border-radius:   0 0 1rem 1rem;
    -webkit-clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 8% 100%);
  clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 8% 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 11;
    transition: left 0.3s ease, filter 0.2s ease;
    outline: none;
    text-align: center;
}
.expand-controls-bottom {
  position: fixed;
   border-radius:  1rem 1rem 0 0 ;
  -webkit-clip-path: polygon(8% 0%, 92% 0%, 100% 100%, 0% 100%);
  clip-path: polygon(8% 0%, 92% 0%, 100% 100%, 0% 100%);
  bottom: 0;
  z-index: 9999;
}


.el-icon-video-pause {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
}

.export-dialog-body .el-checkbox {
  display: block;
  margin-bottom: 0.75rem;
}

.export-dialog-body .el-checkbox:last-of-type {
  margin-bottom: 0;
}

.export-regeo-progress-label {
  margin: 0.75rem 0 0;
  font-size: 0.875rem;
  color: #606266;
  text-align: center;
}

.trajectory-share-dialog-body {
  color: #303133;
  font-size: 0.875rem;
}

.trajectory-share-success-line {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.75rem;
}

.trajectory-share-help,
.trajectory-share-meta {
  margin: 0.5rem 0 0;
  color: #909399;
  font-size: 0.8125rem;
  line-height: 1.5;
}

.trajectory-share-meta {
  margin: 0 0 0.75rem;
}

.trajectory-share-unit {
  margin-left: 0.5rem;
  color: #606266;
}

.trajectory-share-go-link {
  color: var(--layout-primary, #087dff);
  text-decoration: none;
}

.trajectory-share-go-link:hover {
  text-decoration: underline;
}

.trajectory-share-url-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.trajectory-share-url-input {
  min-width: 0;
  flex: 1;
}

/* 去掉 Element 默认的底部 1px 横线 */
.el-table::before {
  height: 0 !important;
}

/* 表格区域设为纯白，避免地图在半透明面板下透出“线条”视觉 */
.el-table,
.el-table th,
.el-table td,
.el-table tr {
  background-color: #fff !important;
}
</style>

<style scoped>
.quality-time-gaps { position: relative; height: 8px; background: #e4e7ed; }
.quality-time-gaps span { position: absolute; height: 8px; background: #909399; }
</style>
